<template>
  <div class="main-container">
    <div class="container-wrapper converter-workspace" @click.self="toggleMenu">
      <div class="calcolatrice">
        <div
          class="contenitore-f24"
          :class="['contenitore', isShifted ? 'shift-left' : '']"
        >
          <!-- Titolo principale -->
          <div class="header">
            <span class="converter-title-icon" aria-hidden="true">
              <img
                src="/Pagina Convertitore/icona Modelli F24 trasparente.png"
                alt=""
              />
            </span>
            <h3 class="titleConvF24">
              Convertitore <span class="titlef24">MODELLI F24</span>
            </h3>
            <div class="current-plan-container">
              <div :class="['current-plan', currentPlan.toLowerCase()]">
                {{ currentPlan }}
              </div>
            </div>
            <div
              v-if="f24NewExtractorEnabled"
              class="ai-converter-badge ai-converter-badge--f24"
              title="Nuovo estrattore IA attivo per il tuo account"
            >
              <i class="fa-solid fa-wand-magic-sparkles"></i>
              <span>IA attiva</span>
            </div>
          </div>
          <div class="headerButtons headerButtonsf24">
            <router-link to="/home" class="tool-button">
              <i
                title="Torna alla Home"
                class="fa-solid fa-house back backconv"
              ></i>
            </router-link>
            <router-link to="/home/store" class="tool-button">
              <i
                title="Acquista Coin"
                class="fa-solid fa-cart-shopping storeicon icons-conv"
              >
              </i>
            </router-link>
            <i
              title="Reset del convertitore"
              class="fa-solid fa-arrows-rotate refresh icons-conv"
              @click="refreshConversione"
            >
            </i>
          </div>
          <!-- Contenitore degli input -->
          <div class="input-container">
            <div class="converter-file-actions">
              <label for="fileInput" class="input-label input-label--file"
                >Seleziona file da convertire:</label
              >
              <button
                v-if="filePDF_URL"
                @click="openPDFPreview"
                class="btn btn-secondary anteprimapdf"
              >
                <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
                Visualizza PDF
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'excel'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--excel"
              >
                <i class="fa-solid fa-file-excel" aria-hidden="true"></i>
                Visualizza Excel
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'csv'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--csv"
              >
                <i class="fa-solid fa-file-csv" aria-hidden="true"></i>
                Visualizza CSV
              </button>
            </div>
            <input
              id="fileInput"
              class="file-input"
              type="file"
              ref="fileInput"
              @change="handleFileChange"
              :disabled="fase1 || fase2 || fase3 || calculating || calculating2"
            />
            <small class="converter-formats">Formato supportato: PDF</small>
            <span class="softwaredetected" v-show="input_PC">
              <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
              <span class="softwaredetected-label"
                >Software contabile rilevato</span
              >
              <strong class="input_PC">{{ input_PC }}</strong>
            </span>
            <label for="outputSystem" class="input-label input-label--software">
              Software contabile di conversione:
            </label>
            <select
              v-model="output_PC"
              id="outputSystem"
              class="select-input"
              :disabled="fase2 || fase3 || calculating || calculating2"
            >
              <option disabled selected value="">Seleziona software</option>
              <option value="TEAMSYSTEM">TEAMSYSTEM</option>
              <option value="DATEV">DATEV</option>
              <option value="ZUCCHETTI">ZUCCHETTI</option>
              <option value="SEAC">SEAC</option>
              <option value="SISTEMI">SISTEMI</option>
              <!-- <option value="SISTEMI">SISTEMI</option> -->
            </select>

            <!-- Checkbox per CSV importazione diretta -->
            <div
              v-if="output_PC == 'DATEV' || output_PC == 'TEAMSYSTEM'"
              class="container-checkbox"
              :title="
                ha(user, 'import_csv_diretto')
                  ? 'Genera il file CSV pronto per l\'importazione diretta nel tuo gestionale'
                  : 'Disponibile da piano Plus'
              "
            >
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="flag_csv_import"
                :disabled="
                  fase3 ||
                  calculating ||
                  calculating2 ||
                  !ha(user, 'import_csv_diretto')
                "
                id="csv-import-checkbox"
              />
              <label for="csv-import-checkbox" class="csv-label">
                File .csv per importazione diretta
                <span v-if="!ha(user, 'import_csv_diretto')" class="lock-icon">
                  <i class="fa-solid fa-lock"></i>
                </span>
              </label>
            </div>

            <!-- Checkbox per Versione analitica -->
            <div class="container-checkbox">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="isExtendedVersion"
                :disabled="fase3 || calculating || calculating2"
                id="extended-version-checkbox"
              />
              <label for="extended-version-checkbox" class="csv-label"
                >Versione analitica</label
              >
              <span class="info-icon">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span class="tooltip">
                  La Versione Analitica del modello F24 sarà aggiunta ai file
                  convertiti
                </span>
              </span>
            </div>

            <button
              @click="fase_1"
              :disabled="calculating || fase1 || fase2 || fase3"
              class="action-button"
            >
              <span v-if="calculating">
                <div class="spinner"></div>
                Elaborazione...
              </span>
              <span v-else
                ><i class="fa-solid fa-play"></i> Avvia conversione</span
              >
            </button>
            <div
              v-if="errorMessage"
              class="converter-error-alert"
              role="alert"
              aria-live="polite"
            >
              <i
                class="fa-solid fa-triangle-exclamation converter-error-alert__icon"
                aria-hidden="true"
              ></i>
              <div class="converter-error-alert__content">
                <strong>{{ errorAlertTitle }}</strong>
                <span>{{ errorMessage }}</span>
              </div>
            </div>
          </div>
          <ProcessingWaitNotice
            v-if="showDelayedMessage"
            :extended="delayedMessageUpdated"
          />
        </div>
      </div>
      <ConverterWelcomePanel
        v-if="!showResult"
        tone="f24"
        :description="'Importa i modelli F24 da PDF e trasformali in dati\npronti per il tuo software contabile.'"
      />
      <div
        v-show="showResult"
        :class="[
          'result-container',
          showResult ? 'show' : '',
          {
            'result-container--locked': tableInteractionLocked,
            'result-container--quality': fase2 && currentSubPhase === 'Q',
          },
        ]"
        :aria-busy="tableInteractionLocked ? 'true' : 'false'"
        @beforeinput.capture="preventLockedTableInteraction"
        @click.capture="preventLockedTableInteraction"
        @change.capture="preventLockedTableInteraction"
        @input.capture="preventLockedTableInteraction"
        @keydown.capture="preventLockedTableInteraction"
        @focusin.capture="preventLockedTableInteraction"
      >
        <!--------------------- FASE 1 ---------------------->
        <div v-if="fase1" class="fase1">
          <h3 class="title-conv">MODELLI F24 INDIVIDUATI</h3>
          <p class="numerofaseAttuale">Fase 1 di 3</p>
          <AdminMsFiscalCodeGenerator
            :clients="vettoreClienti"
            @apply-code="applyAdminMsFiscalCode"
          />
          <!-- Pulsante per espandere/ridurre la tabella -->
          <div class="response-message">
            <div class="divclient-table" :class="{ expanded: isTableExpanded }">
              <table
                class="client-table"
                :class="{ 'client-table-datev': output_PC === 'DATEV' }"
              >
                <thead>
                  <i
                    @click="toggleTableExpansion"
                    :class="
                      isTableExpanded
                        ? 'fa-solid fa-compress expand-button-clienti'
                        : 'fa-solid fa-expand expand-button-clienti'
                    "
                    title="Espandi / Comprimi Tabella"
                  ></i>
                  <tr>
                    <th v-if="settings.flag_mostra_codice_ditta">
                      Codice ditta
                    </th>
                    <th>Denominazione cliente</th>
                    <th>Data</th>
                    <th>Codice fiscale</th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Aziende
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(1)"
                      >
                        ✔
                      </button>
                    </th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Lib. Prof.
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(2)"
                      >
                        ✔
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cliente, index) in vettoreClienti" :key="index">
                    <td v-if="settings.flag_mostra_codice_ditta">
                      <!-- Codice ditta -->
                      <input
                        type="text"
                        v-model.trim="cliente[0]"
                        placeholder="Inserisci Codice ditta"
                        title="Inserisci Codice ditta"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        maxlength="8"
                        @input="
                          cliente[0] = $event.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )
                        "
                        class="input-editable"
                        :class="{ 'input-valorizzato': cliente[0]?.trim() }"
                      />
                    </td>

                    <td>
                      <!-- Denominazione pulita -->
                      {{ getNomeF24(cliente[1]) }}
                    </td>

                    <td>
                      <input
                        v-model.trim="paymentDates[index]"
                        class="input-editable"
                        placeholder="gg-mm-aaaa"
                        aria-label="Data pagamento obbligatoria"
                        maxlength="10"
                        required
                      />
                    </td>

                    <td>
                      <input
                        v-model.trim="cliente[4]"
                        placeholder="Inserisci Codice fiscale"
                        title="Inserisci Codice fiscale"
                        class="input-editable"
                        maxlength="16"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        :class="{
                          'filled-input':
                            cliente[4] && cliente[4].trim() !== '',
                          'invalid-input':
                            cliente[4] && !isValidCodiceFiscale(cliente[4]),
                        }"
                        @input="formattaCFPI($event, cliente)"
                      />
                    </td>

                    <!-- Colonne DATEV (invariate) -->
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-' + index"
                        :value="1"
                        v-model.number="vettoreClienti[index][2]"
                      />
                    </td>
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-' + index"
                        :value="2"
                        v-model.number="vettoreClienti[index][2]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="conversion-summary-box document-summary-box"
              :class="{
                'normal-margin':
                  creditiDisponibili &lt; numeroClienti * creditiPerF24,
                'extra-margin':
                  creditiDisponibili >= numeroClienti * creditiPerF24,
              }"
            >
              <div class="summary-row">
                <span class="label">Modelli F24 individuati:</span>
                <span class="value">{{ numeroClienti }}</span>
              </div>
              <div class="summary-row">
                <span class="label">Clienti individuati:</span>
                <span class="value">{{ f24DistinctClientsCount }}</span>
              </div>
              <div class="summary-row">
                <span class="label">Coin disponibili:</span>
                <span class="value">{{ creditiDisponibili }}</span>
              </div>
              <div class="summary-row">
                <span class="label"
                  >Costo di conversione:
                  <span class="info-icon-coin">
                    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                    <span class="tooltip-coin">
                      I Coin saranno addebitati al Download del file
                    </span>
                  </span></span
                >
                <span class="value"
                  ><span class="costoincoin">{{
                    numeroClienti * creditiPerF24
                  }}</span
                  ><i class="fa-solid fa-coins"></i
                ></span>
              </div>
              <div
                v-if="creditiDisponibili < numeroClienti * creditiPerF24"
                class="crediti-insufficienti-msg"
              >
                <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                Non hai Coin a sufficienza
              </div>
              <div
                v-if="creditiDisponibili < numeroClienti * creditiPerF24"
                class="acquista-coin-box"
                @click="showCoinPurchase = !showCoinPurchase"
              >
                <i class="fa-solid fa-cart-shopping"></i>
                <span>Acquista Coin</span>
              </div>
            </div>
            <!-- Modal overlay -->
            <div
              v-if="showCoinPurchase"
              class="modal-overlay"
              @click.self="showCoinPurchase = false"
            >
              <div class="modal-content">
                <button class="modal-close" @click="showCoinPurchase = false">
                  &times;
                </button>

                <CoinPurchase
                  :options="conversionOptions"
                  :loading="isProcessing"
                  :messagePurchase="messagePurchase"
                  @coins-updated="fetchConversionCount"
                />
              </div>
            </div>
            <button
              class="btnfase2"
              @click="fase_2"
              :disabled="
                calculating2 ||
                creditiDisponibili * creditiPerF24 < numeroClienti
              "
              :title="
                creditiDisponibili < numeroClienti
                  ? 'Non hai abbastanza Coin disponibili'
                  : ''
              "
            >
              <span v-if="calculating2">
                <div class="spinner"></div>
                Elaborazione...
              </span>
              <span v-else>Prosegui conversione</span>
            </button>
          </div>
        </div>
        <!--------------------- FASE 2 ---------------------->
        <div
          v-if="fase2"
          class="fase2"
          :class="{ 'f24-bank-phase': currentSubPhase === 'C' }"
        >
          <p class="numerofaseAttuale">Fase 2 di 3</p>
          <!-- Messaggio di risposta -->
          <div
            class="response-message fase2-results-body conversion-table-surface"
            :class="{
              'dashboard-table-expanded': currentF24DashboardExpanded,
              'pdc-client-table-mode':
                currentSubPhase === 'A' && pctClientTableMode === 'client',
            }"
          >
            <!-- Titoli specifici per ciascuna sub-fase -->
            <h3
              v-if="currentSubPhase === 'Q'"
              class="cod-conto-individuati title-conv"
            >
              CONTROLLO QUALIT&Agrave; DOCUMENTO
            </h3>
            <h3
              v-if="currentSubPhase === 'A'"
              class="cod-conto-individuati title-conv"
            >
              CODICI TRIBUTO INDIVIDUATI
            </h3>
            <h3
              v-if="currentSubPhase === 'B'"
              class="cod-conto-individuati title-conv"
            >
              CODICI TRIBUTO 9001
            </h3>
            <h3
              v-if="currentSubPhase === 'C'"
              class="cod-conto-individuati title-conv"
            >
              COORDINATE BANCARIE
            </h3>
            <ConversionDiagnosticsModal
              v-if="currentSubPhase === 'Q' && hasF24QualityDiagnostics"
              :visible="true"
              :summary="conversionDiagnosticsModal.summary"
              :processed-clients="[]"
              :can-go-back="conversionDiagnosticsModal.notificationIndex > 0"
              :can-review-sections="false"
              :inline="true"
              :final-action-label="f24QualityFinalActionLabel"
              @close="advanceF24QualityDiagnostics"
              @back="goBackF24QualityDiagnostics"
            />
            <p
              v-if="currentSubPhase !== 'Q' && !availableDataPhases.length"
              class="f24-empty-phase"
            >
              Nessun codice tributo o coordinata bancaria da configurare nel
              modello caricato.
            </p>

            <div
              v-if="currentSubPhase === 'A' && showF24CodTributoDashboard"
              class="codconto-table-dashboard f24-table-dashboard"
            >
              <div class="codconto-dashboard-tools">
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-icon-button"
                  :disabled="!currentF24CodTributoHasRows"
                  title="Espandi / Comprimi tabella"
                  @click="toggleCurrentF24CodTributoExpansion"
                >
                  <i
                    :class="
                      currentF24CodTributoExpanded
                        ? 'fa-solid fa-compress'
                        : 'fa-solid fa-expand'
                    "
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button"
                  :class="{ active: currentF24CodTributoIsEditing }"
                  :disabled="!canUseCurrentF24CodTributoEdit"
                  :title="currentF24CodTributoEditTitle"
                  @click="toggleCurrentF24CodTributoEditMode"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                  <span>{{ currentF24CodTributoEditLabel }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-save"
                  :disabled="!currentF24CodTributoHasChanges"
                  title="Salva modifiche"
                  @click="saveCurrentF24CodTributoTable"
                >
                  <i class="fa-solid fa-floppy-disk"></i>
                  <span>Salva</span>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-icon-button"
                  :disabled="!currentF24CodTributoCanUndo"
                  title="Annulla ultima modifica"
                  @click="undoCurrentF24CodTributoTable"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-reset"
                  :disabled="!currentF24CodTributoHasChanges"
                  title="Annulla tutte le modifiche"
                  @click="resetCurrentF24CodTributoTable"
                >
                  Annulla
                </button>
              </div>
              <div class="codconto-dashboard-filters">
                <div
                  v-show="vettoreCodTributoPCT.length > 0"
                  class="codconto-code-view-controls"
                >
                  <button
                    type="button"
                    class="codconto-code-view-trigger codconto-dashboard-filter"
                    :class="{ active: f24CodTributoViewDropdownOpen }"
                    @click.stop="toggleF24CodTributoViewDropdown"
                  >
                    <i
                      :class="
                        vettorePCTVisible
                          ? 'fa-solid fa-book'
                          : 'fa-solid fa-list-check'
                      "
                      class="iconbtnPDC"
                    ></i>
                    <span>{{
                      vettorePCTVisible ? "Codici salvati" : "Nuovi codici"
                    }}</span>
                    <i
                      :class="
                        f24CodTributoViewDropdownOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      class="toggle-icon"
                    ></i>
                  </button>
                  <div
                    v-if="f24CodTributoViewDropdownOpen"
                    class="codconto-code-view-menu"
                  >
                    <button
                      type="button"
                      :class="{ active: !vettorePCTVisible }"
                      @click="selectF24CodTributoView(false)"
                    >
                      <i class="fa-solid fa-list"></i>
                      <span>Nuovi codici</span>
                    </button>
                    <button
                      type="button"
                      :class="{ active: vettorePCTVisible }"
                      @click="selectF24CodTributoView(true)"
                    >
                      <i class="fa-solid fa-book"></i>
                      <span>Codici salvati</span>
                    </button>
                  </div>
                </div>
                <div class="pdc-client-view-controls">
                  <button
                    class="pdc-client-view-trigger"
                    type="button"
                    :disabled="!hasPctClientOptions"
                    :title="
                      hasPctClientOptions
                        ? 'Seleziona vista clienti'
                        : 'La vista per cliente non e disponibile per questa elaborazione'
                    "
                    @click.stop="toggleF24PctClientViewDropdown"
                  >
                    <i class="fa-solid fa-users"></i>
                    <span>{{ currentF24PctClientSelectionLabel }}</span>
                    <i
                      :class="
                        f24PctClientDropdownOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                    ></i>
                  </button>
                  <div
                    v-if="f24PctClientDropdownOpen && hasPctClientOptions"
                    class="pdc-client-view-menu"
                  >
                    <div class="pdc-client-view-menu-title">Clienti</div>
                    <button
                      type="button"
                      :class="{ active: pctClientTableMode === 'all' }"
                      @click="selectF24PctScope('')"
                    >
                      Tutti
                    </button>
                    <button
                      v-for="client in pctClientOptions"
                      :key="client.key"
                      type="button"
                      :class="{
                        active:
                          pctClientTableMode === 'client' &&
                          selectedPctClientKey === client.key,
                      }"
                      @click="selectF24PctScope(client.key)"
                    >
                      {{ client.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="currentSubPhase === 'A' && pctClientTableMode === 'client'"
              class="f24-client-context-note"
            >
              <i class="fa-solid fa-circle-info"></i>
              <span>
                Le modifiche vengono salvate solo per questo cliente. I codici
                non modificati continuano a seguire il piano globale.
              </span>
            </div>

            <div
              v-if="currentSubPhase === 'B' && showF249001Dashboard"
              class="codconto-table-dashboard f24-table-dashboard"
            >
              <div class="codconto-dashboard-tools">
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-icon-button"
                  :disabled="!currentF249001HasRows"
                  title="Espandi / Comprimi tabella"
                  @click="toggleCurrentF249001Expansion"
                >
                  <i
                    :class="
                      currentF249001Expanded
                        ? 'fa-solid fa-compress'
                        : 'fa-solid fa-expand'
                    "
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-save"
                  :disabled="!currentF249001HasChanges"
                  title="Salva modifiche"
                  @click="saveCurrentF249001Table"
                >
                  <i class="fa-solid fa-floppy-disk"></i>
                  <span>Salva</span>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-icon-button"
                  :disabled="!currentF249001CanUndo"
                  title="Annulla ultima modifica"
                  @click="undoCurrentF249001Table"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-reset"
                  :disabled="!currentF249001HasChanges"
                  title="Annulla tutte le modifiche"
                  @click="resetCurrentF249001Table"
                >
                  Annulla
                </button>
              </div>
              <div class="codconto-dashboard-filters">
                <div
                  class="f24-9001-code-context"
                  aria-label="Codice tributo 9001"
                >
                  <span>Codice tributo</span>
                  <span class="f24-9001-code-badge">9001</span>
                </div>
                <div
                  v-show="vettoreCodTributo9001_PCT?.length > 0"
                  class="codconto-code-view-controls"
                >
                  <button
                    type="button"
                    class="codconto-code-view-trigger codconto-dashboard-filter"
                    :class="{ active: f249001ViewDropdownOpen }"
                    @click.stop="toggleF249001ViewDropdown"
                  >
                    <i
                      :class="
                        vettore9001PCTVisible
                          ? 'fa-solid fa-book'
                          : 'fa-solid fa-list-check'
                      "
                      class="iconbtnPDC"
                    ></i>
                    <span>{{
                      vettore9001PCTVisible ? "9001 salvati" : "Nuovi 9001"
                    }}</span>
                    <i
                      :class="
                        f249001ViewDropdownOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      class="toggle-icon"
                    ></i>
                  </button>
                  <div
                    v-if="f249001ViewDropdownOpen"
                    class="codconto-code-view-menu"
                  >
                    <button
                      type="button"
                      :class="{ active: !vettore9001PCTVisible }"
                      @click="selectF249001View(false)"
                    >
                      <i class="fa-solid fa-list"></i>
                      <span>Nuovi 9001</span>
                    </button>
                    <button
                      type="button"
                      :class="{ active: vettore9001PCTVisible }"
                      @click="selectF249001View(true)"
                    >
                      <i class="fa-solid fa-book"></i>
                      <span>9001 salvati</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenuti specifici per sub-fase A -->
            <div v-if="currentSubPhase === 'A'" class="f24-subphase-content">
              <button
                v-show="vettoreCodTributoPCT.length > 0"
                class="btnPCTvisible legacy-f24-table-control"
                :class="{ active: vettorePCTVisible }"
                @click="vettorePCTVisible = !vettorePCTVisible"
              >
                <i class="fa-solid fa-book iconbtnPDC"></i>
                Codici Tributo già salvati
                <i
                  :class="
                    vettorePCTVisible
                      ? 'fa-solid fa-chevron-down'
                      : 'fa-solid fa-chevron-right'
                  "
                  class="toggle-icon"
                ></i>
              </button>

              <!-- TABELLA ESPANDIBILE PER PCT (salvati) -->
              <div
                class="divPCTtable"
                :class="{ 'table-hidden': !vettorePCTVisible }"
              >
                <div
                  v-show="vettoreCodTributoPCT.length > 0 && vettorePCTVisible"
                  class="cod_conto_table_divPCT"
                  :class="{ expanded: isTableTributoPCTExpanded }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotablePCT-datev'
                        : 'codcontotablePCT'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTableTributoPCTExpansion"
                        :class="
                          isTableTributoPCTExpanded
                            ? 'fa-solid fa-compress expand-buttontributo'
                            : 'fa-solid fa-expand expand-buttontributo'
                        "
                        class="legacy-f24-table-control"
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th
                          class="headerIndici saved-library-header"
                          title="Già nel tuo Piano Codici Tributo"
                          aria-label="Già nel tuo Piano Codici Tributo"
                        >
                          <i
                            class="fa-solid fa-book saved-library-header-icon"
                            aria-hidden="true"
                          ></i>
                        </th>
                        <th
                          v-for="(header, index) in filteredHeadersPCT"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreCodTributoPCT"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumnsPCT"
                          :key="colIndex"
                          :class="[
                            {
                              'datev-column':
                                filteredHeadersPCT[colIndex] ===
                                  'Cod. tributo Datev Aziende' ||
                                filteredHeadersPCT[colIndex] ===
                                  'Cod. tributo Datev Liberi Professionisti',
                              'italic-text':
                                hasNessunaCorrelazione(
                                  vettoreCodTributoPCT[rowIndex][col]
                                ) ||
                                isNessuno(vettoreCodTributoPCT[rowIndex][col]),
                              'f24-client-custom-cell':
                                isF24ClientCellSavedDifferentFromGlobal(
                                  'f24-pct',
                                  rowIndex,
                                  col
                                ),
                            },
                            tableCellEditClasses(
                              'f24-pct',
                              rowIndex,
                              col,
                              isF24CellInvalid(
                                rowIndex,
                                colIndex,
                                vettoreCodTributoPCT
                              )
                            ),
                          ]"
                        >
                          <template v-if="isEditableColumnPCT(col, rowIndex)">
                            <input
                              v-model="vettoreCodTributoPCT[rowIndex][col]"
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    vettoreCodTributoPCT[rowIndex][col]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    vettoreCodTributoPCT[rowIndex][col]
                                  ),
                              }"
                              :placeholder="
                                isDescrizioneCodContoColumn(
                                  filteredHeaders[colIndex]
                                )
                                  ? 'Inserisci Descrizione Codice Conto'
                                  : ''
                              "
                              @input="
                                handleF24CellInput(
                                  'f24-pct',
                                  rowIndex,
                                  colIndex,
                                  col,
                                  vettoreCodTributoPCT
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoF24Table('f24-pct', vettoreCodTributoPCT)
                              "
                              @keydown.exact="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  col,
                                  colIndex,
                                  vettoreCodTributoPCT
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'f24-pct',
                                  rowIndex,
                                  col,
                                  isF24CellInvalid(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributoPCT
                                  )
                                )
                              "
                            >
                              {{
                                vettoreCodTributoPCT[rowIndex][col] === "None"
                                  ? ""
                                  : vettoreCodTributoPCT[rowIndex][col]
                              }}
                            </span>
                          </template>
                          <span
                            v-if="
                              isF24ClientCellSavedDifferentFromGlobal(
                                'f24-pct',
                                rowIndex,
                                col
                              )
                            "
                            class="f24-client-custom-marker"
                            title="Valore personalizzato salvato rispetto al piano globale"
                          >
                            <i class="fa-solid fa-user-pen"></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button
                  v-if="vettoreCodTributoPCT.length > 0 && vettorePCTVisible"
                  key="edit-btn-pct"
                  class="edit-buttonPDC legacy-f24-table-control"
                  :class="{
                    'active-editbuttonPDC':
                      isEditModePCT && hasTableChanges('f24-pct'),
                    'editing-editbuttonPDC':
                      isEditModePCT && !hasTableChanges('f24-pct'),
                  }"
                  @click="
                    isEditModePCT
                      ? saveF24Table('f24-pct', vettoreCodTributoPCT)
                      : toggleEditModePCT()
                  "
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Modifica Codici Conto già salvati - Disponibile da piano Plus'
                      : 'Modifica Codici Conto già salvati'
                  "
                >
                  <i
                    :class="
                      isEditModePCT
                        ? 'fa-solid fa-floppy-disk edit-button-icon'
                        : 'fa-regular fa-pen-to-square edit-button-icon'
                    "
                  ></i>
                  <span class="edit-button-text">{{
                    isEditModePCT ? "Salva modifiche" : "Modifica"
                  }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <div
                  v-if="
                    vettoreCodTributoPCT.length > 0 &&
                    vettorePCTVisible &&
                    hasTableChanges('f24-pct')
                  "
                  class="edit-session-actions legacy-f24-table-control"
                >
                  <button
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('f24-pct')"
                    @click="undoF24Table('f24-pct', vettoreCodTributoPCT)"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('f24-pct')"
                    @click="resetF24Table('f24-pct', 'vettoreCodTributoPCT')"
                  >
                    Annulla
                  </button>
                </div>
              </div>
              <!-- Contenuto principale per A quando non visibile il PCT -->
              <div v-if="!vettorePCTVisible">
                <div
                  v-if="vettoreCodTributo.length > 0 && !vettorePCTVisible"
                  class="cod_conto_table_div"
                  :class="{
                    expanded: isTableExpanded,
                  }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codtributotable-datev'
                        : 'codtributotable'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTableExpansion"
                        :class="
                          isTableExpanded
                            ? 'fa-solid fa-compress expand-buttontributo'
                            : 'fa-solid fa-expand expand-buttontributo'
                        "
                        class="legacy-f24-table-control"
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          {{ header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreCodTributo"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(realColIndex, colIndex) in validColumns"
                          :key="colIndex"
                          :class="[
                            {
                              'italic-text':
                                hasNessunaCorrelazione(
                                  vettoreCodTributo[rowIndex][realColIndex]
                                ) ||
                                isNessuno(
                                  vettoreCodTributo[rowIndex][realColIndex]
                                ),
                              'f24-client-custom-cell':
                                isF24ClientCellSavedDifferentFromGlobal(
                                  'f24-main',
                                  rowIndex,
                                  realColIndex
                                ),
                            },
                            tableCellEditClasses(
                              'f24-main',
                              rowIndex,
                              realColIndex,
                              isF24CellInvalid(
                                rowIndex,
                                colIndex,
                                vettoreCodTributo
                              )
                            ),
                          ]"
                        >
                          <template
                            v-if="isEditableColumn(realColIndex, rowIndex)"
                          >
                            <input
                              v-model="
                                vettoreCodTributo[rowIndex][realColIndex]
                              "
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    vettoreCodTributo[rowIndex][realColIndex]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    vettoreCodTributo[rowIndex][realColIndex]
                                  ),
                              }"
                              :placeholder="
                                isDescrizioneCodContoColumn(
                                  filteredHeaders[colIndex]
                                )
                                  ? 'Inserisci Descrizione Codice Conto'
                                  : ''
                              "
                              @input="
                                handleF24CellInput(
                                  'f24-main',
                                  rowIndex,
                                  colIndex,
                                  realColIndex,
                                  vettoreCodTributo
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoF24Table('f24-main', vettoreCodTributo)
                              "
                              @keydown.exact="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  realColIndex,
                                  colIndex,
                                  vettoreCodTributo
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'f24-main',
                                  rowIndex,
                                  realColIndex,
                                  isF24CellInvalid(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributo
                                  )
                                )
                              "
                            >
                              {{
                                vettoreCodTributo[rowIndex][realColIndex] ===
                                "None"
                                  ? ""
                                  : vettoreCodTributo[rowIndex][realColIndex]
                              }}
                            </span>
                          </template>
                          <span
                            v-if="
                              isF24ClientCellSavedDifferentFromGlobal(
                                'f24-main',
                                rowIndex,
                                realColIndex
                              )
                            "
                            class="f24-client-custom-marker"
                            title="Valore personalizzato salvato rispetto al piano globale"
                          >
                            <i class="fa-solid fa-user-pen"></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-else
                  class="success-container"
                  :class="{
                    'success-container--with-subphases':
                      availablePhases.length > 1,
                  }"
                >
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p
                    class="checkcodiciconto"
                    :class="{
                      'checkcodicitributo-saldo':
                        Array.isArray(vettoreCodSaldoFinale) &&
                        vettoreCodSaldoFinale.length > 0,
                    }"
                  >
                    Tutti i Codici Tributo individuati nel Modello F24 sono già
                    presenti nel tuo
                    <span class="scrittapiano">Piano Codici Tributo</span>
                  </p>
                </div>
                <button
                  v-if="
                    vettoreCodTributo.length > 0 &&
                    !vettorePCTVisible &&
                    isPiano(user, 'premium')
                  "
                  class="edit-button"
                  :class="{
                    'legacy-f24-table-control': true,
                    'editing-editbutton': isEditMode,
                  }"
                  @click="toggleEditMode"
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Personalizza Descrizioni Codici Conto - Disponibile da piano Plus'
                      : 'Personalizza Descrizioni Codici Conto'
                  "
                >
                  <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                  <span class="edit-button-text">{{
                    isEditMode ? "Chiudi" : "Personalizza"
                  }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <div
                  v-if="
                    vettoreCodTributo.length > 0 &&
                    !vettorePCTVisible &&
                    hasTableChanges('f24-main')
                  "
                  class="edit-session-actions legacy-f24-table-control"
                >
                  <button
                    class="edit-button active-editbutton edit-session-save"
                    type="button"
                    title="Salva modifiche"
                    @click="saveF24Table('f24-main', vettoreCodTributo)"
                  >
                    <i class="fa-solid fa-floppy-disk edit-button-icon"></i>
                    <span class="edit-button-text">Salva modifiche</span>
                  </button>
                  <button
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('f24-main')"
                    @click="undoF24Table('f24-main', vettoreCodTributo)"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('f24-main')"
                    @click="resetF24Table('f24-main', 'vettoreCodTributo')"
                  >
                    Annulla
                  </button>
                </div>
              </div>
            </div>

            <div v-if="currentSubPhase === 'B'" class="f24-subphase-content">
              <!-- Pulsante toggle per i codici 9001 già salvati -->
              <button
                v-show="vettoreCodTributo9001_PCT?.length > 0"
                class="btnPCTvisible legacy-f24-table-control"
                :class="{ active: vettore9001PCTVisible }"
                @click="vettore9001PCTVisible = !vettore9001PCTVisible"
              >
                <i class="fa-solid fa-book iconbtnPDC"></i>
                Codici 9001 già salvati
                <i
                  :class="
                    vettore9001PCTVisible
                      ? 'fa-solid fa-chevron-down'
                      : 'fa-solid fa-chevron-right'
                  "
                  class="toggle-icon"
                ></i>
              </button>

              <!-- TABELLA ESPANDIBILE PER PCT (salvati) – visibile SOLO se toggle attivo -->
              <div
                class="divPCTtable"
                :class="{ 'table-hidden': !vettore9001PCTVisible }"
              >
                <div
                  v-show="
                    vettoreCodTributo9001_PCT?.length > 0 &&
                    vettore9001PCTVisible
                  "
                  class="cod_conto_table_divPCT"
                  :class="{ expanded: isTable9001PCTExpanded }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotable9001PCT-datev'
                        : 'codcontotable9001PCT'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTable9001PCTExpansion"
                        class="legacy-f24-table-control"
                        :class="
                          isTable9001PCTExpanded
                            ? 'fa-solid fa-compress expand-buttontributo'
                            : 'fa-solid fa-expand expand-buttontributo'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th
                          class="headerIndici saved-library-header"
                          title="Già nel tuo Piano Codici Tributo"
                          aria-label="Già nel tuo Piano Codici Tributo"
                        >
                          <i
                            class="fa-solid fa-book saved-library-header-icon"
                            aria-hidden="true"
                          ></i>
                        </th>
                        <th
                          v-for="(header, index) in filteredHeaders9001"
                          :key="index"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreCodTributo9001_PCT"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="colIndex in validColumns9001"
                          :key="colIndex"
                          :class="[
                            {
                              'italic-text':
                                hasNessunaCorrelazione(
                                  mapped9001(
                                    rowIndex,
                                    vettoreCodTributo9001_PCT
                                  )[colIndex]
                                ) ||
                                isNessuno(
                                  mapped9001(
                                    rowIndex,
                                    vettoreCodTributo9001_PCT
                                  )[colIndex]
                                ),
                            },
                            tableCellEditClasses(
                              'f24-9001-pct',
                              rowIndex,
                              get9001RealColIndex(colIndex),
                              is9001CellInvalid(
                                rowIndex,
                                colIndex,
                                vettoreCodTributo9001_PCT
                              )
                            ),
                          ]"
                        >
                          <template
                            v-if="isEditable9001(colIndex, 'f24-9001-pct')"
                          >
                            <input
                              v-model="
                                inputValues9001[`pct-${rowIndex}-${colIndex}`]
                              "
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    mapped9001(
                                      rowIndex,
                                      vettoreCodTributo9001_PCT
                                    )[colIndex]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    mapped9001(
                                      rowIndex,
                                      vettoreCodTributo9001_PCT
                                    )[colIndex]
                                  ),
                              }"
                              :placeholder="
                                isDescrizioneCodContoColumn(
                                  headers9001[colIndex]
                                )
                                  ? 'Inserisci Descrizione Codice Conto'
                                  : ''
                              "
                              @input="
                                handle9001CellInput(
                                  'f24-9001-pct',
                                  rowIndex,
                                  colIndex,
                                  $event,
                                  vettoreCodTributo9001_PCT
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoF24Table(
                                  'f24-9001-pct',
                                  vettoreCodTributo9001_PCT
                                )
                              "
                              @keydown.exact="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  colIndex,
                                  colIndex,
                                  vettoreCodTributo9001_PCT
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'f24-9001-pct',
                                  rowIndex,
                                  get9001RealColIndex(colIndex),
                                  is9001CellInvalid(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributo9001_PCT
                                  )
                                )
                              "
                            >
                              {{
                                mapped9001(rowIndex, vettoreCodTributo9001_PCT)[
                                  colIndex
                                ] === "None"
                                  ? ""
                                  : mapped9001(
                                      rowIndex,
                                      vettoreCodTributo9001_PCT
                                    )[colIndex]
                              }}
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Contenuto principale – sempre visibile quando toggle chiuso -->
              <div
                v-if="
                  vettoreCodTributo9001_PCT?.length > 0 && vettore9001PCTVisible
                "
                class="edit-session-actions legacy-f24-table-control"
              >
                <button
                  class="edit-buttonPDC"
                  :class="{
                    'active-editbuttonPDC':
                      isEditMode9001PCT && hasTableChanges('f24-9001-pct'),
                    'editing-editbuttonPDC':
                      isEditMode9001PCT && !hasTableChanges('f24-9001-pct'),
                  }"
                  type="button"
                  @click="
                    isEditMode9001PCT
                      ? saveF24Table('f24-9001-pct', vettoreCodTributo9001_PCT)
                      : toggleEditMode9001PCT()
                  "
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  title="Modifica Codici Tributo 9001 gia salvati"
                >
                  <i
                    :class="
                      isEditMode9001PCT
                        ? 'fa-solid fa-floppy-disk edit-button-icon'
                        : 'fa-regular fa-pen-to-square edit-button-icon'
                    "
                  ></i>
                  <span class="edit-button-text">{{
                    isEditMode9001PCT ? "Salva modifiche" : "Modifica"
                  }}</span>
                </button>
                <button
                  v-if="hasTableChanges('f24-9001-pct')"
                  class="edit-session-utility"
                  type="button"
                  title="Annulla ultima modifica"
                  :disabled="!hasTableUndo('f24-9001-pct')"
                  @click="
                    undoF24Table('f24-9001-pct', vettoreCodTributo9001_PCT)
                  "
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
                <button
                  v-if="hasTableChanges('f24-9001-pct')"
                  class="edit-session-utility reset-all"
                  type="button"
                  title="Annulla tutte le modifiche"
                  :disabled="!hasTableChanges('f24-9001-pct')"
                  @click="
                    resetF24Table('f24-9001-pct', 'vettoreCodTributo9001_PCT')
                  "
                >
                  Annulla
                </button>
              </div>

              <div v-if="!vettore9001PCTVisible">
                <!-- Tabella codici nuovi (priorità massima) -->
                <div
                  v-if="vettoreCodTributo9001?.length > 0"
                  class="vettore9001-table"
                  :class="{ expanded: isTable9001Expanded }"
                >
                  <table>
                    <thead>
                      <i
                        @click="toggleTable9001Expansion"
                        class="legacy-f24-table-control"
                        :class="
                          isTable9001Expanded
                            ? 'fa-solid fa-compress expand-button9001'
                            : 'fa-solid fa-expand expand-button9001'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeaders9001"
                          :key="index"
                        >
                          {{ header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreCodTributo9001"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="colIndex in validColumns9001"
                          :key="colIndex"
                          :class="[
                            {
                              'italic-text':
                                hasNessunaCorrelazione(
                                  mapped9001(rowIndex, vettoreCodTributo9001)[
                                    colIndex
                                  ]
                                ) ||
                                isNessuno(
                                  mapped9001(rowIndex, vettoreCodTributo9001)[
                                    colIndex
                                  ]
                                ),
                            },
                            tableCellEditClasses(
                              'f24-9001',
                              rowIndex,
                              get9001RealColIndex(colIndex),
                              is9001CellInvalid(
                                rowIndex,
                                colIndex,
                                vettoreCodTributo9001
                              )
                            ),
                          ]"
                        >
                          <template v-if="isEditable9001(colIndex, 'f24-9001')">
                            <input
                              v-model="
                                inputValues9001[`${rowIndex}-${colIndex}`]
                              "
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    inputValues9001[`${rowIndex}-${colIndex}`]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    inputValues9001[`${rowIndex}-${colIndex}`]
                                  ),
                              }"
                              :placeholder="
                                colIndex === 6
                                  ? 'Inserisci Descrizione Codice Conto'
                                  : ''
                              "
                              @input="
                                handle9001CellInput(
                                  'f24-9001',
                                  rowIndex,
                                  colIndex,
                                  $event,
                                  vettoreCodTributo9001
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoF24Table('f24-9001', vettoreCodTributo9001)
                              "
                              @keydown.exact="
                                colIndex === 7
                                  ? blockLetters(
                                      $event,
                                      rowIndex,
                                      colIndex,
                                      colIndex,
                                      vettoreCodTributo9001
                                    )
                                  : null
                              "
                              @paste="
                                colIndex === 7
                                  ? blockPaste($event, colIndex)
                                  : null
                              "
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'f24-9001',
                                  rowIndex,
                                  get9001RealColIndex(colIndex),
                                  is9001CellInvalid(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributo9001
                                  )
                                )
                              "
                            >
                              {{
                                mapped9001(rowIndex, vettoreCodTributo9001)[
                                  colIndex
                                ] === "None"
                                  ? ""
                                  : mapped9001(rowIndex, vettoreCodTributo9001)[
                                      colIndex
                                    ]
                              }}
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="vettoreCodTributo9001?.length > 0"
                  class="edit-session-actions legacy-f24-table-control"
                >
                  <button
                    class="edit-button"
                    :class="{ 'editing-editbutton': isEditMode9001 }"
                    type="button"
                    @click="toggleEditMode9001"
                    :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                    title="Modifica Codici Tributo 9001"
                  >
                    <i
                      :class="
                        isEditMode9001
                          ? 'fa-solid fa-pen-to-square edit-button-icon'
                          : 'fa-regular fa-pen-to-square edit-button-icon'
                      "
                    ></i>
                    <span class="edit-button-text">{{
                      isEditMode9001 ? "Chiudi" : "Personalizza"
                    }}</span>
                  </button>
                  <button
                    v-if="hasTableChanges('f24-9001')"
                    class="edit-button active-editbutton edit-session-save"
                    type="button"
                    title="Salva modifiche"
                    @click="saveF24Table('f24-9001', vettoreCodTributo9001)"
                  >
                    <i class="fa-solid fa-floppy-disk edit-button-icon"></i>
                    <span class="edit-button-text">Salva modifiche</span>
                  </button>
                  <button
                    v-if="hasTableChanges('f24-9001')"
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('f24-9001')"
                    @click="undoF24Table('f24-9001', vettoreCodTributo9001)"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    v-if="hasTableChanges('f24-9001')"
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('f24-9001')"
                    @click="resetF24Table('f24-9001', 'vettoreCodTributo9001')"
                  >
                    Annulla
                  </button>
                </div>

                <!-- Messaggio successo solo se NON ci sono nuovi ma ci sono PCT -->
                <div
                  v-else-if="vettoreCodTributo9001_PCT?.length > 0"
                  class="success-container"
                  :class="{
                    'success-container--with-subphases':
                      availablePhases.length > 1,
                  }"
                >
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Tutti i codici tributo 9001 individuati nel Modello F24 sono
                    già presenti nel tuo
                    <span class="scrittapiano">Piano Codici Tributo</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-show="currentSubPhase === 'C'" class="f24-subphase-content">
              <F24BankCoordinatesTable
                v-if="bankCandidateGroups.length"
                v-model="vettoreCodSaldoFinale"
                :candidates="bankCandidateGroups"
                :clients="vettoreClienti"
                :software="output_PC"
                :reserved-account="codContoDefault"
                :disabled="tableInteractionLocked"
                :expanded="isTableSaldoExpanded"
                @toggle-expand="toggleTableSaldoExpansion"
              />
            </div>
            <!-- Navigazione tra sub-fasi e bottone Converti solo sull'ultima -->
            <div
              v-if="availablePhases.length && currentSubPhase !== 'Q'"
              class="subphase-navigation"
            >
              <button
                v-show="!isFirstPhase"
                @click="prevSubPhase"
                class="prev-subphase-btn"
                title="Indietro"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </button>
              <button
                v-show="!isLastPhase"
                @click="nextSubPhase"
                class="next-subphase-btn"
                title="Avanti"
              >
                <i class="fa-solid fa-arrow-right"></i>
              </button>
              <button
                v-if="isLastPhase"
                class="btnfase2"
                @click="fase_3"
                :disabled="calculating2"
              >
                <span v-if="calculating2">
                  <div class="spinner"></div>
                  Elaborazione...
                </span>
                <span v-else>Converti file</span>
              </button>
            </div>
          </div>
        </div>
        <!--------------------- FASE 3 ---------------------->
        <div v-if="fase3" class="fase3">
          <h3 class="anteprimafase3 title-conv">
            ANTEPRIMA DEI MODELLI F24 ELABORATI
          </h3>
          <p class="numerofaseAttuale">Fase 3 di 3</p>
          <!-- Messaggio di risposta -->
          <div
            class="response-message"
            v-if="mergedOverall && mergedOverall.length"
          >
            <div
              class="merged-table-container"
              :class="{ expanded: isTableExpanded }"
            >
              <table class="merged-table merged-table-f24">
                <tbody>
                  <tr
                    v-for="(row, index) in mergedOverall"
                    :key="index"
                    :class="{
                      bilancino: isBilancino(row),
                      rigaCodDescrizione:
                        index > 0 && isBilancino(mergedOverall[index - 1]),
                    }"
                  >
                    <template v-if="isBilancino(row)">
                      <td colspan="3" class="bilancino">
                        <span class="bilancino-name-text">{{ row[0] }}</span>
                      </td>
                    </template>
                    <template v-else>
                      <td>{{ row[0] }}</td>
                      <td>{{ row[1] }}</td>
                      <td>{{ row[2] }}</td>
                    </template>
                  </tr>
                  <span class="expand-button-merged-span">
                    <i
                      @click="toggleTableExpansion"
                      :class="
                        isTableExpanded
                          ? 'fa-solid fa-compress expand-button-merged'
                          : 'fa-solid fa-expand expand-button-merged'
                      "
                      title="Espandi / Comprimi Tabella"
                    ></i>
                  </span>
                </tbody>
              </table>
            </div>
            <div class="scarica-file">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="confermaConversione"
              />
              <label
                >Confermo di aver preso visione dei Codici Conto che vengono
                utilizzati per la conversione.</label
              >
              <span class="info-icon2">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span class="tooltip2">
                  Mi assumo ogni responsabilità dell'utilizzo dei Codici Conto
                  da me selezionati.
                </span>
              </span>
              <p v-if="filePath">
                Il costo della conversione è di&nbsp;
                <span class="costoincoin">
                  {{ numeroClienti * creditiPerF24 }}
                  <i class="fa-solid fa-coins"></i>
                </span>
                <span class="info-icon3">
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  <span class="tooltip3">
                    Il costo viene addebitato solo al primo download. Puoi
                    scaricare il file più volte senza spese aggiuntive.
                  </span>
                </span>
              </p>
              <a
                v-if="filePath"
                href="#"
                @click="handleDownload"
                class="download"
                :class="{
                  'disabled-link': !confermaConversione,
                  'already-downloaded': hasDownloaded,
                }"
              >
                Download
              </a>
            </div>
          </div>
          <div class="skeleton-loader" v-if="!mergedOverall">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-text"></div>
            <div class="skeleton skeleton-button"></div>
          </div>
        </div>
      </div>
      <PDFViewer
        v-if="showPDF"
        :visible="showPDF"
        :src="filePDF_URL"
        :title="fileTitle"
        @close="showPDF = false"
      />
      <ExcelViewer
        v-if="showExcelModal"
        :rows="ExcelRows"
        :visible="showExcelModal"
        :title="fileTitle"
        @close="showExcelModal = false"
      />
      <SimpleErrorModal
        :message="erroreModalMessaggio"
        :isVisible="erroreModalVisibile"
        @close="erroreModalVisibile = false"
      />
      <ConfirmActionModal
        :visible="showResetConfirmModal"
        :title="resetConfirmTitle"
        :eyebrow="resetConfirmEyebrow"
        :message="resetConfirmMessage"
        :confirm-label="resetConfirmConfirmLabel"
        :cancel-label="resetConfirmCancelLabel"
        :icon-class="resetConfirmIconClass"
        :confirm-icon-class="resetConfirmConfirmIconClass"
        :tone="
          ['table-edits', 'table-reset'].includes(resetConfirmContext)
            ? 'info'
            : 'danger'
        "
        @close="handleConfirmActionClose"
        @confirm="handleConfirmActionConfirm"
      />
      <div
        v-if="showCausaleModal"
        class="modal-overlay"
        @click.self="closeF24CausaleModal"
      >
        <div class="causale-modal-content">
          <button
            type="button"
            class="causale-modal-close"
            aria-label="Chiudi"
            @click="closeF24CausaleModal"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <h3>Causale Modelli F24</h3>
          <p>
            Il campo causale non e' presente. Inserisci il campo: il seguente
            valore sara' applicato a tutte le elaborazioni dei modelli F24
            esportate in CSV DATEV. Se vorrai potrai modificarlo in seguito
            dalla Libreria Codici Tributo.
          </p>
          <input
            v-model.trim="causaleDraft"
            class="causale-input"
            type="text"
            maxlength="4"
            autocomplete="off"
            placeholder="B70"
            @input="handleCausaleDraftInput"
            @keyup.enter="saveF24Causale"
          />
          <span v-if="causaleError" class="causale-error">
            {{ causaleError }}
          </span>
          <button
            type="button"
            class="causale-save-button"
            :disabled="savingCausale"
            @click="saveF24Causale"
          >
            <i class="fa-solid fa-floppy-disk"></i>
            Salva
          </button>
        </div>
      </div>
      <PageLoadingOverlay
        :visible="isResettingConversion"
        :min-visible-ms="1000"
        :title="
          resetConfirmContext === 'leave'
            ? 'Uscita dal convertitore'
            : 'Reset del convertitore'
        "
        :message="
          resetConfirmContext === 'leave'
            ? 'Interruzione della conversione prima di cambiare pagina...'
            : 'Interruzione della conversione e pulizia dei dati in corso...'
        "
      />
      <ErrorMessageDisplay
        :errors="errorsData"
        :isVisible="showErrorModal"
        @close="showErrorModal = false"
        @fill-na="fillEmptyWithNA"
        @fill-no-corr="fillEmptyWithNoCorr"
        @proceed-warnings="proceedWithWarnings"
      />
      <ConversionDiagnosticsModal
        :visible="conversionDiagnosticsModal.visible"
        :summary="conversionDiagnosticsModal.summary"
        :backend-message="conversionDiagnosticsModal.backendMessage"
        :processed-clients="[]"
        :can-go-back="false"
        :can-review-sections="false"
        @close="closeF24Diagnostics"
      />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { getUserSettings } from "@/utils/settings.js";
import { haFunzionalita as ha, isPiano } from "@/utils/plans";
import { validFiscalCode } from "@/utils/fiscalCode.js";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import ErrorMessageDisplay from "../components/ErrorMessageDisplay.vue";
import PDFViewer from "@/components/PDFViewer.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import CoinPurchase from "@/components/CoinPurchase.vue";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";
import PageLoadingOverlay from "@/components/PageLoadingOverlay.vue";
import ProcessingWaitNotice from "@/components/ProcessingWaitNotice.vue";
import ConverterWelcomePanel from "@/components/ConverterWelcomePanel.vue";
import ConversionDiagnosticsModal from "@/components/ConversionDiagnosticsModal.vue";
import converterTableEditSession from "@/mixins/converterTableEditSession.js";
import F24BankCoordinatesTable from "@/components/F24BankCoordinatesTable.vue";
import AdminMsFiscalCodeGenerator from "@/components/AdminMsFiscalCodeGenerator.vue";
import {
  initialBankSelection,
  numericPaymentDate,
  bankGroupErrors,
} from "@/utils/f24Banking.js";
import { availableF24SubPhases } from "@/utils/f24Phases.js";
import {
  confirmClientRegistryAssociations,
  isClientRegistryConfirmation,
} from "@/utils/clientRegistryConfirmation.js";

export default {
  name: "ConvModelliF24",
  mixins: [converterTableEditSession],
  components: {
    SimpleErrorModal,
    ErrorMessageDisplay,
    PDFViewer,
    ExcelViewer,
    CoinPurchase,
    ConfirmActionModal,
    PageLoadingOverlay,
    ProcessingWaitNotice,
    ConverterWelcomePanel,
    ConversionDiagnosticsModal,
    F24BankCoordinatesTable,
    AdminMsFiscalCodeGenerator,
  },
  data() {
    return {
      currentPlan: "",
      msg: "",
      userEmail: "", // Inizialmente vuoto, verrà impostato successivamente
      selectedFile: null,
      filePDF_URL: null,
      fileTitle: null,
      jobId: null,
      jobStatus: null,
      jobPollTimer: null,
      isCancelling: false,
      finalConversionInProgress: false,
      showPDF: false,
      showExcelModal: false,
      ExcelRows: [],
      fileType: "",
      excelPath: null,
      mergedOverall: null,
      hasDownloaded: false,
      hasOutputDownloadStarted: false,
      filePath: null,
      vettoreClienti: [],
      paymentDates: [],
      bankCandidateGroups: [],
      vettoreCodTributo: [],
      vettoreCodTributoPCT: [],
      codContoDefault: "11/11/111",
      pctGlobalRows: [],
      pctGlobalPdcRows: [],
      pctGlobalOriginalPdcRows: [],
      pctClientGroups: {
        global: [],
        global_pdc: [],
        custom: [],
        custom_pdc: [],
        non_custom: [],
        non_custom_pdc: [],
      },
      pctClientOriginalGroups: null,
      pctClientTableMode: "all",
      selectedPctClientKey: "",
      diagnosticsSummary: null,
      conversionDiagnosticsModal: {
        visible: false,
        summary: null,
        rootSummary: null,
        notificationQueue: [],
        notificationIndex: 0,
        backendMessage: "",
      },
      vettoreCodTributo9001: [],
      inputValues9001: {},
      isTable9001Expanded: false,
      originalPCT: null,
      vettorePCTVisible: false,
      f24CodTributoViewDropdownOpen: false,
      f249001ViewDropdownOpen: false,
      f24PctClientDropdownOpen: false,
      isTableTributoPCTExpanded: false,
      vettore9001PCTVisible: false,
      isTable9001PCTExpanded: false,
      isEditMode9001PCT: false,
      isEditMode9001: false,
      original9001PCT: null,
      vettoreCodSaldoFinale: [],
      isEditModeSaldoFinale: false,
      editableCells: new Set(), // Tracciamento celle editabili
      headers: [
        "Codice Tributo", // Index 0
        "Descrizione Cod. Conto - TeamSystem", // Index 1
        "Cod. Conto DARE - TeamSystem", // Index 2
        "Cod. Conto AVERE - TeamSystem", // Index 3
        "Descrizione Cod. Conto - Datev Aziende", // Index 4
        "Cod. Conto DARE - Datev Aziende", // Index 5
        "Cod. Conto AVERE - Datev Aziende", // Index 6
        "Descrizione Cod. Conto - Datev Lib. Prof.", // Index 7
        "Cod. Conto DARE - Datev Lib. Prof.", // Index 8
        "Cod. Conto AVERE - Datev Lib. Prof.", // Index 9
        "Descrizione Cod. Conto - Zucchetti", // Index 10
        "Cod. Conto DARE - Zucchetti", // Index 11
        "Cod. Conto AVERE - Zucchetti", // Index 12
        "Descrizione Cod. Conto - SEAC", // Index 13
        "Cod. Conto DARE - SEAC", // Index 14
        "Cod. Conto AVERE - SEAC", // Index 15
        "Descrizione Cod. Conto - Sistemi", // Index 16
        "Cod. Conto DARE - Sistemi", // Index 17
        "Cod. Conto AVERE - Sistemi", // Index 18
        "DARE", // Index 19
        "AVERE", // Index 20
      ],
      headers9001: [
        "Denominazione Cliente", // Index 0
        "Codice Fiscale", // Index 1
        "Data Pagamento", // Index 2
        "Codice Tributo", // Index 3
        "Saldo DARE", // Index 4
        "Saldo AVERE", // Index 5
        "Descrizione Cod. Conto", // Index 6
        "Cod. Conto DARE", // Index 7
        "Cod. Conto AVERE", // Index 8
      ],
      headersSaldoFinale: [
        "Denominazione Cliente", // Index 0
        "Codice Fiscale", // Index 1
        "Codice ABI", // Index 2
        "Codice CAB", // Index 3
        "Data Pagamento", // Index 4
        "Descrizione Cod. Conto", // Index 5 da prendere sempre uguale
        "Cod. Conto AVERE - TeamSystem", // Index 6
        "Cod. Conto AVERE - Datev Aziende", // Index 7
        "Cod. Conto AVERE - Datev Liberi Prof.", // Index 8
        "Cod. Conto AVERE - Zucchetti", // Index 9
        "Cod. Conto AVERE - SEAC", // Index 10
        "Cod. Conto AVERE - Sistemi", // Index 11
      ],
      editingAbiCab: {},
      editingDate: {},
      inputValues: {},
      fase0: false,
      fase1: false,
      fase2: false,
      fase3: false,
      currentSubPhase: "A",
      numeroClienti: 0,
      creditiPerF24: 0,
      calculating: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nella fase di Avvia conversione
      calculating2: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nelle fasi successsive
      input_PC: "",
      output_PC: "",
      output_PCfrontend: "",
      showInfoMenu: false, // Variabile per mostrare/nascondere il menu informazioni
      showDictionaryMenu: false, // Variabile per mostrare/nascondere il menu utente
      showAccountMenu: false, // Variabile per mostrare/nascondere il menu piano conti
      isExtendedVersion: false, // Aggiunto per gestire lo stato del toggle
      flag_output_std: false,
      flag_csv_import: false,
      causaleModelliF24: "",
      causaleDraft: "",
      causaleError: "",
      showCausaleModal: false,
      savingCausale: false,
      retryFase1AfterCausale: false,
      retryFase3AfterCausale: false,
      f24NewExtractorEnabled: false,
      errorMessage: "",
      isShifted: false, // Nuova proprietà per controllare lo spostamento 1
      showResult: false, // Nuova proprietà per controllare lo spostamento 2
      isTableExpanded: false, // Controlla se la tabella è espansa
      isTableSaldoExpanded: false,
      creditiDisponibili: 0,
      confermaConversione: false,
      showDelayedMessage: false,
      delayedMessageUpdated: false,
      delayTimer: null,
      updateTimer: null,
      erroreModalVisibile: false,
      erroreModalMessaggio: "",
      showResetConfirmModal: false,
      isResettingConversion: false,
      resetConfirmContext: "reset",
      resetConfirmTitle: "Interrompere la conversione?",
      resetConfirmEyebrow: "Reset convertitore",
      resetConfirmMessage:
        "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.",
      resetConfirmConfirmLabel: "Interrompi e resetta",
      resetConfirmCancelLabel: "Annulla",
      resetConfirmIconClass: "fa-solid fa-triangle-exclamation",
      resetConfirmConfirmIconClass: "fa-solid fa-arrows-rotate",
      pendingRouteLeaveNext: null,
      pendingRouteLeaveTarget: null,
      pendingTableReset: null,
      showErrorModal: false,
      errorsData: [],
      showCoinPurchase: false,
      restoringFile: false,
      isEditMode: false,
      isEditModePCT: false,
      naConfirmed: false,
      noCorrConfirmed: false,
      settings: {
        flag_saldoProspettiPaghe: true,
        flag_saldoF24: true,
        flag_accorpato: false,
        software_contabile: "default",
        flag_mostra_codice_ditta: true, // default prudente
        // ← qui in futuro aggiungi altri flag senza toccare altro
      },
    };
  },
  computed: {
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    errorAlertTitle() {
      const message = String(this.errorMessage || "").toLowerCase();
      if (message.includes("formato")) return "Formato file non valido";
      if (message.includes("software")) return "Selezione richiesta";
      if (message.includes("annullata")) return "Conversione annullata";
      return "Operazione non completata";
    },
    tableInteractionLocked() {
      return this.calculating2 || this.finalConversionInProgress;
    },
    currentF24DashboardExpanded() {
      if (this.currentSubPhase === "A") {
        return this.currentF24CodTributoExpanded;
      }
      if (this.currentSubPhase === "B") {
        return this.currentF249001Expanded;
      }
      if (this.currentSubPhase === "C") {
        return this.isTableSaldoExpanded;
      }
      return false;
    },
    pctClientOptions() {
      const labels = new Map(
        (this.vettoreClienti || []).map((row) => [
          String(row?.[4] || "")
            .trim()
            .toUpperCase(),
          String(row?.[3] || row?.[4] || "Cliente").trim(),
        ])
      );
      const seen = new Set();
      return [
        ...(this.pctClientGroups.custom || []),
        ...(this.pctClientGroups.non_custom || []),
        ...(this.pctClientGroups.custom_pdc || []),
        ...(this.pctClientGroups.non_custom_pdc || []),
      ]
        .filter((group) => {
          const key = String(group?.client_key || "")
            .trim()
            .toUpperCase();
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .map((group) => ({
          key: String(group.client_key).trim().toUpperCase(),
          label: `${
            labels.get(String(group.client_key).trim().toUpperCase()) ||
            "Cliente"
          } · ${String(group.client_key).trim().toUpperCase()}`,
        }))
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    hasPctClientOptions() {
      return this.pctClientOptions.length > 0;
    },
    currentF24PctClientSelectionLabel() {
      if (this.pctClientTableMode !== "client" || !this.selectedPctClientKey) {
        return "Tutti";
      }
      return (
        this.pctClientOptions.find(
          (client) => client.key === this.selectedPctClientKey
        )?.label || this.selectedPctClientKey
      );
    },
    showF24CodTributoDashboard() {
      return (
        this.currentSubPhase === "A" &&
        ((Array.isArray(this.vettoreCodTributo) &&
          this.vettoreCodTributo.length > 0) ||
          (Array.isArray(this.vettoreCodTributoPCT) &&
            this.vettoreCodTributoPCT.length > 0))
      );
    },
    currentF24CodTributoRows() {
      return this.vettorePCTVisible
        ? this.vettoreCodTributoPCT || []
        : this.vettoreCodTributo || [];
    },
    currentF24CodTributoTableKey() {
      return this.vettorePCTVisible ? "f24-pct" : "f24-main";
    },
    currentF24CodTributoHasRows() {
      return this.currentF24CodTributoRows.length > 0;
    },
    currentF24CodTributoIsEditing() {
      return this.vettorePCTVisible ? this.isEditModePCT : this.isEditMode;
    },
    currentF24CodTributoHasChanges() {
      return this.hasTableChanges(this.currentF24CodTributoTableKey);
    },
    currentF24CodTributoCanUndo() {
      return this.hasTableUndo(this.currentF24CodTributoTableKey);
    },
    currentF24CodTributoExpanded() {
      return this.vettorePCTVisible
        ? this.isTableTributoPCTExpanded
        : this.isTableExpanded;
    },
    currentF24CodTributoEditLabel() {
      if (this.currentF24CodTributoIsEditing) return "Chiudi";
      return this.vettorePCTVisible ? "Modifica" : "Personalizza";
    },
    currentF24CodTributoEditTitle() {
      if (!this.ha(this.user, "modifica_descrizione_nomi_conto")) {
        return this.vettorePCTVisible
          ? "Modifica Codici Tributo gia salvati - Disponibile da piano Plus"
          : "Personalizza Descrizioni Codici Tributo - Disponibile da piano Plus";
      }
      return this.vettorePCTVisible
        ? "Modifica Codici Tributo gia salvati"
        : "Personalizza Descrizioni Codici Tributo";
    },
    canUseCurrentF24CodTributoEdit() {
      return (
        this.currentF24CodTributoHasRows &&
        this.ha(this.user, "modifica_descrizione_nomi_conto") &&
        (this.vettorePCTVisible || this.isPiano(this.user, "premium"))
      );
    },
    showF249001Dashboard() {
      return (
        this.currentSubPhase === "B" &&
        ((Array.isArray(this.vettoreCodTributo9001) &&
          this.vettoreCodTributo9001.length > 0) ||
          (Array.isArray(this.vettoreCodTributo9001_PCT) &&
            this.vettoreCodTributo9001_PCT.length > 0))
      );
    },
    currentF249001Rows() {
      return this.vettore9001PCTVisible
        ? this.vettoreCodTributo9001_PCT || []
        : this.vettoreCodTributo9001 || [];
    },
    currentF249001TableKey() {
      return this.vettore9001PCTVisible ? "f24-9001-pct" : "f24-9001";
    },
    currentF249001TableName() {
      return this.vettore9001PCTVisible
        ? "vettoreCodTributo9001_PCT"
        : "vettoreCodTributo9001";
    },
    currentF249001HasRows() {
      return this.currentF249001Rows.length > 0;
    },
    currentF249001HasChanges() {
      return this.hasTableChanges(this.currentF249001TableKey);
    },
    currentF249001CanUndo() {
      return this.hasTableUndo(this.currentF249001TableKey);
    },
    currentF249001Expanded() {
      return this.vettore9001PCTVisible
        ? this.isTable9001PCTExpanded
        : this.isTable9001Expanded;
    },
    showF24SaldoDashboard() {
      return (
        this.currentSubPhase === "C" &&
        Array.isArray(this.vettoreCodSaldoFinale) &&
        this.vettoreCodSaldoFinale.length > 0
      );
    },
    currentF24SaldoHasRows() {
      return this.showF24SaldoDashboard;
    },
    currentF24SaldoHasChanges() {
      return this.hasTableChanges("f24-saldo");
    },
    currentF24SaldoCanUndo() {
      return this.hasTableUndo("f24-saldo");
    },
    f24DistinctClientsCount() {
      const clientKeys = new Set(
        (this.vettoreClienti || [])
          .map((cliente) => {
            const codiceDitta = cliente?.[0] || "";
            const nome = this.getNomeF24(cliente?.[1]);
            return nome ? `${codiceDitta}|${nome}` : "";
          })
          .filter(Boolean)
      );
      return clientKeys.size || this.numeroClienti;
    },
    validColumnsPCT() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];
      //Per DARE e AVERE None
      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excluded.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    validColumns() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];
      //Per DARE e AVERE None
      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excluded.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    validColumns2() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [7, 8, 9, 10, 11],
        DATEV: [6, 9, 10, 11],
        ZUCCHETTI: [6, 7, 8, 10, 11],
        SEAC: [6, 7, 8, 9, 11],
        SISTEMI: [6, 7, 8, 9, 10],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];
      return this.headersSaldoFinale
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    validColumns9001() {
      return [0, 1, 2, 4, 5, 6, 7, 8];
    },
    filteredHeadersPCT() {
      return this.headers.filter((_, index) =>
        this.validColumnsPCT.includes(index)
      );
    },
    filteredHeaders9001() {
      return this.validColumns9001.map((index) => this.headers9001[index]);
    },
    filteredHeaders() {
      return this.validColumns.map((index) => this.headers[index]);
    },
    availablePhases() {
      return [
        ...(this.hasF24QualityDiagnostics ? ["Q"] : []),
        ...this.availableDataPhases,
      ];
    },
    availableDataPhases() {
      return availableF24SubPhases({
        ordinaryRows: this.vettoreCodTributo,
        savedOrdinaryRows: this.vettoreCodTributoPCT,
        globalOrdinaryRows: this.pctGlobalRows,
        globalSavedOrdinaryRows: this.pctGlobalPdcRows,
        clientGroups: this.pctClientGroups,
        specialRows: this.vettoreCodTributo9001,
        savedSpecialRows: this.vettoreCodTributo9001_PCT,
        bankGroups: this.vettoreCodSaldoFinale,
      });
    },
    hasF24QualityDiagnostics() {
      const summary = this.conversionDiagnosticsModal.rootSummary;
      return Boolean(
        summary &&
          ["warning", "degraded"].includes(summary.status) &&
          this.conversionDiagnosticsModal.notificationQueue.length
      );
    },
    f24QualityFinalActionLabel() {
      return this.availableDataPhases.length
        ? "Vai ai codici individuati"
        : "Converti file";
    },
    isFirstPhase() {
      return (
        this.availablePhases.length > 0 &&
        this.currentSubPhase === this.availablePhases[0]
      );
    },
    isLastPhase() {
      const phases = this.availablePhases;
      return (
        phases.length > 0 && this.currentSubPhase === phases[phases.length - 1]
      );
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.determineCurrentPlan();
      },
    },
    output_PC(value) {
      if (value && this.errorAlertTitle === "Selezione richiesta") {
        this.errorMessage = "";
      }
      if (value === "DATEV" && this.needsF24Causale()) {
        this.openF24CausaleModal();
      }
    },
    flag_csv_import(value) {
      if (value && this.needsF24Causale()) {
        this.openF24CausaleModal();
      }
    },
  },
  methods: {
    ha,
    applyAdminMsFiscalCode({ index, fiscalCode }) {
      const client = this.vettoreClienti[index];
      if (Array.isArray(client)) this.$set(client, 4, fiscalCode);
    },
    normalizeCodContoValue(value) {
      return String(value ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    isCodContoDefault(value) {
      return (
        this.codContoDefault &&
        this.normalizeCodContoValue(value) ===
          this.normalizeCodContoValue(this.codContoDefault)
      );
    },
    normalizeF24PctRows(rows) {
      return (Array.isArray(rows) ? rows : []).map((item) => {
        const row = item && Array.isArray(item.row) ? item.row : item;
        return (Array.isArray(row) ? row : []).map((cell) =>
          cell == null ||
          cell === "None" ||
          cell === "VUOTO" ||
          this.isCodContoDefault(cell)
            ? null
            : cell
        );
      });
    },
    normalizeF24PctClientGroups(payload) {
      const normalized = {};
      [
        "global",
        "global_pdc",
        "custom",
        "custom_pdc",
        "non_custom",
        "non_custom_pdc",
      ].forEach((name) => {
        normalized[name] = (
          Array.isArray(payload?.[name]) ? payload[name] : []
        ).map((group) => {
          const rowSources = {};
          (Array.isArray(group?.rows) ? group.rows : []).forEach((item) => {
            const row = item && Array.isArray(item.row) ? item.row : item;
            const code = String(row?.[0] || "")
              .trim()
              .toUpperCase();
            if (code) {
              rowSources[code] = Boolean(item?.is_cliente_custom);
            }
          });
          return {
            client_key: String(group?.client_key || "")
              .trim()
              .toUpperCase(),
            rows: this.normalizeF24PctRows(group?.rows),
            row_sources: rowSources,
          };
        });
      });
      return normalized;
    },
    findF24PctClientGroup(groups, clientKey, saved = false) {
      const customName = saved ? "custom_pdc" : "custom";
      const fallbackName = saved ? "non_custom_pdc" : "non_custom";
      return (
        (groups[customName] || []).find(
          (group) => group.client_key === clientKey
        ) ||
        (groups[fallbackName] || []).find(
          (group) => group.client_key === clientKey
        ) ||
        null
      );
    },
    normalizeF24ClientCellValue(value) {
      if (value == null || value === "None" || value === "VUOTO") return "";
      return String(value).trim();
    },
    getCurrentF24PctClientGroup(tableKey) {
      if (this.pctClientTableMode !== "client") return null;
      return this.findF24PctClientGroup(
        this.pctClientGroups,
        this.selectedPctClientKey,
        tableKey === "f24-pct"
      );
    },
    getF24GlobalRowForClientRow(tableKey, clientRow) {
      const rowCode = String(clientRow?.[0] || "")
        .trim()
        .toUpperCase();
      if (!rowCode) return null;
      const globalRows =
        tableKey === "f24-pct" ? this.pctGlobalPdcRows : this.pctGlobalRows;
      return (
        (globalRows || []).find(
          (row) =>
            String(row?.[0] || "")
              .trim()
              .toUpperCase() === rowCode
        ) || null
      );
    },
    isF24ClientCellDifferentFromGlobal(tableKey, rowIndex, colIndex) {
      if (this.pctClientTableMode !== "client" || colIndex === 0) return false;
      const clientGroup = this.getCurrentF24PctClientGroup(tableKey);
      const clientRow = clientGroup?.rows?.[rowIndex];
      if (!clientRow) return false;
      const globalRow = this.getF24GlobalRowForClientRow(tableKey, clientRow);
      const clientValue = this.normalizeF24ClientCellValue(clientRow[colIndex]);
      // An empty client cell inherits the global value; it is not a customization.
      if (!clientValue) return false;
      if (!globalRow) return Boolean(clientValue);
      return (
        clientValue !== this.normalizeF24ClientCellValue(globalRow[colIndex])
      );
    },
    isF24ClientCellSavedDifferentFromGlobal(tableKey, rowIndex, colIndex) {
      if (
        !this.isF24ClientCellDifferentFromGlobal(
          tableKey,
          rowIndex,
          colIndex
        ) ||
        this.isTableCellDirty(tableKey, rowIndex, colIndex)
      ) {
        return false;
      }
      const clientGroup = this.getCurrentF24PctClientGroup(tableKey);
      const rowCode = String(clientGroup?.rows?.[rowIndex]?.[0] || "")
        .trim()
        .toUpperCase();
      return Boolean(rowCode && clientGroup?.row_sources?.[rowCode]);
    },
    markCurrentF24ClientRowsAsSaved(tableKey) {
      if (this.pctClientTableMode !== "client") return;
      const clientGroup = this.getCurrentF24PctClientGroup(tableKey);
      if (!clientGroup) return;
      if (!clientGroup.row_sources) {
        this.$set(clientGroup, "row_sources", {});
      }
      const dirtyRowIndexes = [
        ...new Set(
          Object.keys(this.tableEditSessions?.[tableKey]?.dirtyCells || {}).map(
            (key) => Number(String(key).split("-")[0])
          )
        ),
      ].filter((rowIndex) => Number.isInteger(rowIndex));

      dirtyRowIndexes.forEach((rowIndex) => {
        const row = clientGroup.rows?.[rowIndex];
        const rowCode = String(row?.[0] || "")
          .trim()
          .toUpperCase();
        if (!rowCode) return;
        const isCustom = (row || []).some((_, colIndex) =>
          this.isF24ClientCellDifferentFromGlobal(tableKey, rowIndex, colIndex)
        );
        this.$set(clientGroup.row_sources, rowCode, isCustom);
      });
    },
    persistCurrentF24PctScope() {
      if (this.pctClientTableMode === "all") {
        this.pctGlobalRows = this.vettoreCodTributo;
        this.pctGlobalPdcRows = this.vettoreCodTributoPCT;
        return;
      }
      const current = this.findF24PctClientGroup(
        this.pctClientGroups,
        this.selectedPctClientKey,
        false
      );
      const currentSaved = this.findF24PctClientGroup(
        this.pctClientGroups,
        this.selectedPctClientKey,
        true
      );
      if (current) current.rows = this.vettoreCodTributo;
      if (currentSaved) currentSaved.rows = this.vettoreCodTributoPCT;
    },
    selectF24PctScope(clientKey) {
      this.persistCurrentF24PctScope();
      const normalizedKey = String(clientKey || "")
        .trim()
        .toUpperCase();
      this.selectedPctClientKey = normalizedKey;
      this.pctClientTableMode = normalizedKey ? "client" : "all";
      this.f24PctClientDropdownOpen = false;

      if (!normalizedKey) {
        this.vettoreCodTributo = this.pctGlobalRows;
        this.vettoreCodTributoPCT = this.pctGlobalPdcRows;
      } else {
        this.vettoreCodTributo =
          this.findF24PctClientGroup(this.pctClientGroups, normalizedKey, false)
            ?.rows || [];
        this.vettoreCodTributoPCT =
          this.findF24PctClientGroup(this.pctClientGroups, normalizedKey, true)
            ?.rows || [];
      }

      this.originalPCT = JSON.parse(
        JSON.stringify(this.vettoreCodTributoPCT || [])
      );
      this.primeTableEditSession(
        "f24-main",
        normalizedKey ? "CODICI TRIBUTO CLIENTE" : "CODICI TRIBUTO INDIVIDUATI",
        this.vettoreCodTributo,
        true
      );
      this.primeTableEditSession(
        "f24-pct",
        normalizedKey
          ? "CODICI TRIBUTO CLIENTE SALVATI"
          : "CODICI TRIBUTO GIÀ SALVATI",
        this.vettoreCodTributoPCT,
        true
      );
      if (this.vettorePCTVisible && !this.vettoreCodTributoPCT.length) {
        this.vettorePCTVisible = false;
      }
    },
    propagateF24GlobalPctRowsToClientGroups(tableKey, rows) {
      if (
        this.pctClientTableMode !== "all" ||
        !["f24-main", "f24-pct"].includes(tableKey)
      ) {
        return;
      }

      const targetGroupBuckets =
        tableKey === "f24-pct"
          ? [
              {
                name: "non_custom_pdc",
                groups: this.pctClientGroups.non_custom_pdc || [],
              },
              {
                name: "custom_pdc",
                groups: this.pctClientGroups.custom_pdc || [],
              },
            ]
          : [
              {
                name: "non_custom",
                groups: this.pctClientGroups.non_custom || [],
              },
              {
                name: "custom",
                groups: this.pctClientGroups.custom || [],
              },
            ];
      const targetGroups = targetGroupBuckets.flatMap(
        (bucket) => bucket.groups || []
      );
      if (!targetGroups.length) return;

      const rowsByCode = new Map(
        (rows || [])
          .filter((row) => row?.[0])
          .map((row) => [String(row[0]).trim().toUpperCase(), row])
      );
      const maxCopyIndex = Math.min(this.headers.length, 19);

      targetGroupBuckets.forEach((bucket) => {
        (bucket.groups || []).forEach((group) => {
          const rowSources = group?.row_sources || {};
          const originalGroup = (
            this.pctClientOriginalGroups?.[bucket.name] || []
          ).find((candidate) => candidate.client_key === group.client_key);
          const originalRowsByCode = new Map(
            (originalGroup?.rows || [])
              .filter((row) => row?.[0])
              .map((row) => [String(row[0]).trim().toUpperCase(), row])
          );

          (group?.rows || []).forEach((clientRow) => {
            const code = String(clientRow?.[0] || "")
              .trim()
              .toUpperCase();
            const globalRow = rowsByCode.get(code);
            if (!globalRow || rowSources[code]) return;
            const originalRow = originalRowsByCode.get(code);
            for (let index = 0; index < maxCopyIndex; index += 1) {
              const propagatedValue = globalRow[index] ?? null;
              this.$set(clientRow, index, propagatedValue);
              if (originalRow) {
                this.$set(originalRow, index, propagatedValue);
              }
            }
          });
        });
      });
    },
    f24PctRowsChanged(currentRows, originalRows) {
      return (
        JSON.stringify(currentRows || []) !== JSON.stringify(originalRows || [])
      );
    },
    buildF24ClientPctUpdates() {
      const updates = { custom: [], custom_pdc: [] };
      for (const client of this.pctClientOptions) {
        const currentNew = this.findF24PctClientGroup(
          this.pctClientGroups,
          client.key,
          false
        );
        const currentSaved = this.findF24PctClientGroup(
          this.pctClientGroups,
          client.key,
          true
        );
        const originalNew = this.findF24PctClientGroup(
          this.pctClientOriginalGroups || {},
          client.key,
          false
        );
        const originalSaved = this.findF24PctClientGroup(
          this.pctClientOriginalGroups || {},
          client.key,
          true
        );
        const collectChangedRows = (current, original) => {
          const originals = new Map(
            (original?.rows || []).map((row) => [String(row?.[0] || ""), row])
          );
          return (current?.rows || []).filter(
            (row) =>
              JSON.stringify(row) !==
              JSON.stringify(originals.get(String(row?.[0] || "")))
          );
        };
        const changedNew = collectChangedRows(currentNew, originalNew);
        const changedSaved = collectChangedRows(currentSaved, originalSaved);
        if (changedNew.length) {
          updates.custom.push({ client_key: client.key, rows: changedNew });
        }
        if (changedSaved.length) {
          updates.custom_pdc.push({
            client_key: client.key,
            rows: changedSaved,
          });
        }
      }
      return updates;
    },
    validateF24ClientPctUpdates(groups) {
      const triples =
        {
          TEAMSYSTEM: [[1, 2, 3]],
          DATEV: [
            [4, 5, 6],
            [7, 8, 9],
          ],
          ZUCCHETTI: [[10, 11, 12]],
          SEAC: [[13, 14, 15]],
          SISTEMI: [[16, 17, 18]],
        }[this.output_PC] || [];
      for (const group of [
        ...(groups.custom || []),
        ...(groups.custom_pdc || []),
      ]) {
        for (const row of group.rows || []) {
          let completeProfiles = 0;
          for (const [descriptionIndex, debitIndex, creditIndex] of triples) {
            const values = [
              row?.[descriptionIndex],
              row?.[debitIndex],
              row?.[creditIndex],
            ].map((value) => String(value ?? "").trim());
            if (values.some(Boolean) && !values.every(Boolean)) {
              this.erroreModalMessaggio = `Completa descrizione, conto Dare e conto Avere per il codice tributo ${row?.[0]} del cliente ${group.client_key}.`;
              this.erroreModalVisibile = true;
              return false;
            }
            if (values.every(Boolean)) completeProfiles += 1;
            if (
              this.isCodContoDefault(values[1]) ||
              this.isCodContoDefault(values[2])
            ) {
              this.erroreModalMessaggio = `Il conto ${this.codContoDefault} è riservato e non può essere salvato.`;
              this.erroreModalVisibile = true;
              return false;
            }
          }
          if (!completeProfiles) {
            this.erroreModalMessaggio = `Completa descrizione, conto Dare e conto Avere per il codice tributo ${row?.[0]} del cliente ${group.client_key}.`;
            this.erroreModalVisibile = true;
            return false;
          }
        }
      }
      return true;
    },
    showF24Diagnostics(summary, backendMessage = "") {
      this.diagnosticsSummary = summary || null;
      if (!summary?.has_user_visible_diagnostics) {
        this.conversionDiagnosticsModal = {
          visible: false,
          summary: null,
          rootSummary: null,
          notificationQueue: [],
          notificationIndex: 0,
          backendMessage: "",
        };
        return false;
      }
      const notificationQueue = Array.isArray(summary.user_notifications)
        ? summary.user_notifications
        : [];
      if (!notificationQueue.length) return false;
      const showAsBlockingModal = summary.status === "failed";
      this.conversionDiagnosticsModal = {
        visible: showAsBlockingModal,
        summary: this.activeF24DiagnosticNotification(
          summary,
          notificationQueue,
          0
        ),
        rootSummary: summary,
        notificationQueue,
        notificationIndex: 0,
        backendMessage,
      };
      return showAsBlockingModal;
    },
    activeF24DiagnosticNotification(summary, queue, index) {
      const notification = queue[index];
      return {
        ...summary,
        status: notification.status || summary.status,
        user_title: notification.user_title || summary.user_title,
        user_message: notification.user_message || summary.user_message,
        support_message: notification.support_message || "",
        user_events: notification.user_events || [],
        current_notification_kind: notification.kind,
        has_more_notifications: index < queue.length - 1,
      };
    },
    closeF24Diagnostics() {
      const modal = this.conversionDiagnosticsModal;
      const nextIndex = modal.notificationIndex + 1;
      if (nextIndex >= modal.notificationQueue.length) {
        modal.visible = false;
        return;
      }
      modal.notificationIndex = nextIndex;
      modal.summary = this.activeF24DiagnosticNotification(
        modal.rootSummary,
        modal.notificationQueue,
        nextIndex
      );
    },
    advanceF24QualityDiagnostics() {
      const modal = this.conversionDiagnosticsModal;
      const nextIndex = modal.notificationIndex + 1;
      if (nextIndex < modal.notificationQueue.length) {
        modal.notificationIndex = nextIndex;
        modal.summary = this.activeF24DiagnosticNotification(
          modal.rootSummary,
          modal.notificationQueue,
          nextIndex
        );
        return;
      }
      const qualityIndex = this.availablePhases.indexOf("Q");
      const nextPhase = this.availablePhases[qualityIndex + 1];
      if (nextPhase) {
        this.currentSubPhase = nextPhase;
        return;
      }
      this.fase_3();
    },
    goBackF24QualityDiagnostics() {
      const modal = this.conversionDiagnosticsModal;
      const previousIndex = modal.notificationIndex - 1;
      if (previousIndex < 0) return;
      modal.notificationIndex = previousIndex;
      modal.summary = this.activeF24DiagnosticNotification(
        modal.rootSummary,
        modal.notificationQueue,
        previousIndex
      );
    },
    preventLockedTableInteraction(event) {
      if (!this.tableInteractionLocked) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const interactiveTarget = target.closest(
        [
          "input",
          "select",
          "textarea",
          "button",
          "label",
          "[contenteditable='true']",
          ".edit-button",
          ".btn-select",
          ".datev-config-toggle",
          ".datev-config-nav",
          ".datev-section-row",
        ].join(",")
      );

      if (!interactiveTarget) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof interactiveTarget.blur === "function") {
        interactiveTarget.blur();
      }
      if (target !== interactiveTarget && typeof target.blur === "function") {
        target.blur();
      }
    },
    toggleF24CodTributoViewDropdown() {
      if (!this.vettoreCodTributoPCT.length) return;
      this.f24CodTributoViewDropdownOpen = !this.f24CodTributoViewDropdownOpen;
      this.f249001ViewDropdownOpen = false;
      this.f24PctClientDropdownOpen = false;
    },
    toggleF24PctClientViewDropdown() {
      if (!this.hasPctClientOptions) return;
      this.f24PctClientDropdownOpen = !this.f24PctClientDropdownOpen;
      if (this.f24PctClientDropdownOpen) {
        this.f24CodTributoViewDropdownOpen = false;
        this.f249001ViewDropdownOpen = false;
      }
    },
    closeF24CodTributoViewDropdown() {
      this.f24CodTributoViewDropdownOpen = false;
      this.f249001ViewDropdownOpen = false;
      this.f24PctClientDropdownOpen = false;
    },
    selectF24CodTributoView(showSaved) {
      this.vettorePCTVisible = showSaved;
      this.f24CodTributoViewDropdownOpen = false;
      this.f24PctClientDropdownOpen = false;
    },
    toggleF249001ViewDropdown() {
      if (!this.vettoreCodTributo9001_PCT?.length) return;
      this.f249001ViewDropdownOpen = !this.f249001ViewDropdownOpen;
      this.f24CodTributoViewDropdownOpen = false;
      this.f24PctClientDropdownOpen = false;
    },
    selectF249001View(showSaved) {
      this.vettore9001PCTVisible = showSaved;
      this.f249001ViewDropdownOpen = false;
      this.f24PctClientDropdownOpen = false;
    },
    isPiano,
    determineCurrentPlan() {
      if (isPiano(this.user, "premium")) {
        this.currentPlan = "Premium";
      } else if (isPiano(this.user, "plus")) {
        this.currentPlan = "Plus";
      } else {
        this.currentPlan = "Base";
      }
    },
    getJobStorageKey() {
      return "conversion-job:f24";
    },
    isPersistableJobStatus(status) {
      return ["queued", "running", "cancel_requested"].includes(status);
    },
    isPollableJobStatus(status) {
      return ["queued", "running", "cancel_requested"].includes(status);
    },
    isConversionBusy() {
      return (
        (this.jobId &&
          !["completed", "failed", "cancelled"].includes(this.jobStatus)) ||
        this.calculating ||
        this.calculating2
      );
    },
    hasUndownloadedCompletedOutput() {
      return (
        this.fase3 && Boolean(this.filePath) && !this.hasOutputDownloadStarted
      );
    },
    shouldConfirmReset() {
      if (this.hasUndownloadedCompletedOutput()) {
        return true;
      }

      return (
        this.isConversionBusy() &&
        (this.calculating ||
          this.calculating2 ||
          this.fase1 ||
          this.fase2 ||
          this.fase3)
      );
    },
    openConversionInterruptModal(context, routeNext = null) {
      this.resetConfirmContext = context;
      this.pendingRouteLeaveNext = routeNext;

      if (this.hasUndownloadedCompletedOutput()) {
        this.resetConfirmTitle =
          context === "leave"
            ? "Uscire senza scaricare?"
            : "Resettare senza scaricare?";
        this.resetConfirmEyebrow = "Download non ancora eseguito";
        this.resetConfirmMessage =
          context === "leave"
            ? "La conversione è terminata, ma il file elaborato non è stato scaricato. Uscendo dalla pagina perderai questo risultato."
            : "La conversione è terminata, ma il file elaborato non è stato scaricato. Resettando il convertitore perderai questo risultato.";
        this.resetConfirmConfirmLabel =
          context === "leave"
            ? "Esci senza scaricare"
            : "Resetta senza scaricare";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass =
          context === "leave"
            ? "fa-solid fa-right-from-bracket"
            : "fa-solid fa-arrows-rotate";
      } else if (context === "leave") {
        this.resetConfirmTitle = "Uscire dalla pagina?";
        this.resetConfirmEyebrow = "Conversione in corso";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Uscendo dalla pagina interromperai l'elaborazione e i dati temporanei verranno puliti.";
        this.resetConfirmConfirmLabel = "Interrompi e Esci";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-right-from-bracket";
      } else {
        this.resetConfirmTitle = "Interrompere la conversione?";
        this.resetConfirmEyebrow = "Reset convertitore";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.";
        this.resetConfirmConfirmLabel = "Interrompi e resetta";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-arrows-rotate";
      }

      this.resetConfirmIconClass = "fa-solid fa-triangle-exclamation";
      this.showResetConfirmModal = true;
    },
    cancelConversionInterrupt() {
      if (this.pendingRouteLeaveNext) {
        this.pendingRouteLeaveNext(false);
      }
      this.showResetConfirmModal = false;
      this.pendingRouteLeaveNext = null;
      this.pendingRouteLeaveTarget = null;
      this.resetConfirmContext = "reset";
    },
    shouldConfirmTableEditsBeforeConversion() {
      return (
        !this.pendingTableEditConversion &&
        this.pendingTableEditLabels.length > 0
      );
    },
    openTableEditsConversionConfirm() {
      const labels = this.pendingTableEditLabels.join(", ");
      this.resetConfirmContext = "table-edits";
      this.resetConfirmTitle = "Salvare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche non confermate";
      this.resetConfirmMessage = `Hai modifiche non salvate in: ${labels}. Vuoi salvarle e proseguire con la conversione?`;
      this.resetConfirmConfirmLabel = "Salva e converti";
      this.resetConfirmCancelLabel = "Annulla";
      this.resetConfirmIconClass = "fa-solid fa-circle-info";
      this.resetConfirmConfirmIconClass = "fa-solid fa-floppy-disk";
      this.showResetConfirmModal = true;
    },
    handleConfirmActionClose() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        this.pendingTableReset = null;
        return;
      }
      this.cancelConversionInterrupt();
    },
    handleConfirmActionConfirm() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.commitAllF24TableEdits();
        this.resetConfirmContext = "reset";
        this.pendingTableEditConversion = true;
        this.$nextTick(() => {
          this.fase_3();
          this.pendingTableEditConversion = false;
        });
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.confirmResetF24Table();
        this.resetConfirmContext = "reset";
        return;
      }
      this.confirmResetDuringJob();
    },
    commitAllF24TableEdits() {
      this.commitTableEditSession("f24-main", this.vettoreCodTributo);
      this.commitTableEditSession("f24-pct", this.vettoreCodTributoPCT);
      this.commitTableEditSession("f24-9001", this.vettoreCodTributo9001);
      this.commitTableEditSession(
        "f24-9001-pct",
        this.vettoreCodTributo9001_PCT
      );
      this.commitTableEditSession("f24-saldo", this.vettoreCodSaldoFinale);
      this.isEditMode = false;
      this.isEditModePCT = false;
      this.isEditMode9001 = false;
      this.isEditMode9001PCT = false;
      this.isEditModeSaldoFinale = false;
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async waitForResetOverlayMinimum(startedAt) {
      const remaining = Math.max(1000 - (Date.now() - startedAt), 0);
      if (remaining > 0) {
        await this.wait(remaining);
      }
    },
    navigateHomeSafely() {
      if (this.shouldConfirmReset()) {
        this.pendingRouteLeaveTarget = "/home";
        this.openConversionInterruptModal("leave");
        return;
      }

      this.$router.push("/home");
    },
    persistJobState() {
      if (this.jobId && this.isPersistableJobStatus(this.jobStatus)) {
        sessionStorage.setItem(
          this.getJobStorageKey(),
          JSON.stringify({
            jobId: this.jobId,
            finalConversionInProgress: this.finalConversionInProgress,
          })
        );
      } else {
        this.removePersistedJobState();
      }
    },
    removePersistedJobState() {
      sessionStorage.removeItem(this.getJobStorageKey());
    },
    async cleanupPurgeableJobs() {
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/cleanup_purgeable`, {
          tool: "modello_f24",
        });
      } catch (error) {
        console.error("Errore durante il cleanup dei job F24:", error);
      }
    },
    async cleanupSpecificJob(jobId) {
      if (!jobId) return;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`);
      } catch (error) {
        if (![404, 409].includes(error.response?.status)) {
          console.error("Errore durante il cleanup del job:", error);
        }
      }
    },
    async waitForJobToBecomePurgeable(jobId, timeoutMs = 5000) {
      if (!jobId) return false;
      const deadline = Date.now() + timeoutMs;
      while (Date.now() < deadline) {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/conversion_jobs/${jobId}/status`
          );
          const status = response.data.job?.status;
          if (["draft", "completed", "failed", "cancelled"].includes(status)) {
            return true;
          }
        } catch (error) {
          if (error.response?.status === 404) {
            return true;
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 400));
      }
      return false;
    },
    handleWindowBeforeUnload(event) {
      if (this.hasUndownloadedCompletedOutput()) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
      return undefined;
    },
    handleWindowPageHide() {
      if (!this.jobId) return;
      const jobId = this.jobId;
      if (this.isPollableJobStatus(this.jobStatus)) {
        fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`, {
          method: "POST",
          credentials: "include",
          keepalive: true,
        }).catch(() => {});
        return;
      }
      fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`, {
        method: "POST",
        credentials: "include",
        keepalive: true,
      }).catch(() => {});
    },
    clearJobState() {
      this.stopJobPolling();
      this.jobId = null;
      this.jobStatus = null;
      this.isCancelling = false;
      this.finalConversionInProgress = false;
      this.persistJobState();
    },
    stopJobPolling() {
      if (this.jobPollTimer) {
        clearInterval(this.jobPollTimer);
        this.jobPollTimer = null;
      }
    },
    startJobPolling() {
      this.stopJobPolling();
      if (!this.jobId) return;
      this.fetchJobStatus();
      this.jobPollTimer = setInterval(() => {
        this.fetchJobStatus(true);
      }, 2500);
    },
    async fetchJobStatus(silent = false) {
      if (!this.jobId) return;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/status`
        );
        this.applyJobState(response.data.job);
      } catch (error) {
        if (error.response?.status === 404) {
          this.calculating = false;
          this.calculating2 = false;
          this.stopJobPolling();
          this.clearJobState();
          return;
        }
        if (!silent) {
          console.error("Errore nel recupero dello stato job:", error);
        }
      }
    },
    applyJobState(job) {
      if (!job) return;
      this.jobId = job.job_id;
      this.jobStatus = job.status;
      this.persistJobState();

      if (job.status === "draft") {
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.stopJobPolling();
        this.clearJobState();
        return;
      }

      this.isShifted = true;
      this.showResult = true;
      this.fase0 = false;

      if (job.status === "completed") {
        this.removePersistedJobState();
        this.filePath = job.result_file_name;
        this.filesNames = job.result_files || [];
        this.downloadType = job.result_file_type;
        this.hasOutputDownloadStarted = false;
        this.fileName =
          job.result_file_type === "zip"
            ? "Modelli F24.zip"
            : job.result_file_name;
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.fase1 = false;
        this.fase2 = false;
        this.fase3 = true;
        this.errorMessage = "";
        this.stopJobPolling();
        this.getMergedOverall();
        return;
      }

      if (job.status === "failed") {
        const failedJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = job.error_message || job.message || "Errore job";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(failedJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      if (job.status === "cancelled") {
        const cancelledJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = "Conversione annullata.";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(cancelledJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      this.calculating = false;
      this.calculating2 = true;
      this.fase1 = false;
      this.fase2 = true;
      this.fase3 = false;
    },
    async resumeStoredJob() {
      const raw = sessionStorage.getItem(this.getJobStorageKey());
      if (!raw) return;
      try {
        const parsed = JSON.parse(raw);
        if (!parsed?.jobId) return;
        this.jobId = parsed.jobId;
        this.finalConversionInProgress = Boolean(
          parsed.finalConversionInProgress
        );
        await this.fetchJobStatus();
        if (this.jobId && this.isPollableJobStatus(this.jobStatus)) {
          this.startJobPolling();
        }
      } catch (error) {
        console.error("Errore nel ripristino del job:", error);
      }
    },
    async cancelActiveJob(resetAfter = true) {
      if (!this.jobId) {
        if (resetAfter) this.resetConversione();
        return;
      }
      const jobId = this.jobId;
      this.isCancelling = true;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`);
      } catch (error) {
        console.error("Errore nell'annullamento del job:", error);
      } finally {
        this.isCancelling = false;
      }
      await this.waitForJobToBecomePurgeable(jobId);
      await this.cleanupSpecificJob(jobId);
      await this.cleanupPurgeableJobs();
      this.stopJobPolling();
      this.clearJobState();
      if (resetAfter) {
        this.resetConversione();
      }
    },
    fase_1() {
      if (this.selectedFile) {
        if (!this.output_PC) {
          this.errorMessage =
            "Devi selezionare il Software contabile di conversione!";
          setTimeout(() => {
            this.errorMessage = "";
          }, 4000);
          return;
        }
        if (this.needsF24Causale()) {
          this.openF24CausaleModal({ retryFase1AfterSave: true });
          return;
        }
        this.excelPath = null;
        this.calculating = true; // Mostra il messaggio di calcolo in corso
        this.errorMessage = "";
        const formData = new FormData();
        this.jobId = this.jobId || crypto.randomUUID();
        formData.append("pdfFile", this.selectedFile);
        formData.append("output_PC", this.output_PC);
        formData.append("job_id", this.jobId);

        this.startDelayMessageTimer();
        axios
          .post(`${API_BASE_URL}/conversione_f24_fase_1`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.clearDelayMessageTimer();
            this.jobId = res.data.job_id || this.jobId;
            this.input_PC = res.data.input_PC;
            this.vettoreClienti = res.data.vettoreClienti;
            this.paymentDates = this.vettoreClienti.map((client) => {
              const date = numericPaymentDate(this.getDataF24(client[1]));
              return date === "01-01-1970" ? "" : date;
            });
            console.log("this.vettoreClienti:");
            console.log(this.vettoreClienti);
            this.numeroClienti = res.data.numeroClienti;
            this.creditiDisponibili = res.data.crediti_disponibili;
            this.codContoDefault =
              res.data.codContoDefault || this.codContoDefault;
            // La diagnostica viene prodotta in fase 1, ma viene mostrata solo
            // dopo la fase 2 per mantenere lo stesso flusso degli altri convertitori.
            this.diagnosticsSummary = res.data.diagnostics_summary || null;
            this.conversionDiagnosticsModal.visible = false;
            this.fase1 = true;
            return this.nextConversionStep(); // Mantiene il loading durante l'ingresso dei risultati
          })
          .catch((err) => {
            this.clearDelayMessageTimer();
            if (err.response?.data?.code === "JOB_ALREADY_RUNNING") {
              this.applyJobState(err.response.data.job);
              this.startJobPolling();
              return;
            }
            // Qui gestisci l'errore ricevuto dal backend
            if (err.response && err.response.data && err.response.data.error) {
              this.errorMessage = err.response.data.error; // Mostra il messaggio di errore ricevuto
              this.showF24Diagnostics(
                err.response.data.diagnostics_summary,
                err.response.data.error
              );
            } else {
              this.errorMessage = "Errore nella richiesta al server.";
            }
            this.fase1 = false;
          })
          .then(() => {
            this.calculating = false; // Nasconde il messaggio di calcolo in corso
            if (this.errorMessage) {
              setTimeout(() => {
                this.errorMessage = null;
              }, 3500);
            }
          });
      }
    },
    fase_2(registryConfirmed = false) {
      const dates = this.paymentDates.map(numericPaymentDate);
      if (
        dates.length !== this.vettoreClienti.length ||
        dates.some((date) => !date || date === "01-01-1970")
      ) {
        this.erroreModalMessaggio =
          "Inserisci una data di pagamento valida (gg-mm-aaaa) per ogni modello. La data predefinita 01-01-1970 deve essere sostituita.";
        this.erroreModalVisibile = true;
        return;
      }
      this.paymentDates = dates;
      // Controllo per output_PC "D": tutti i clienti devono avere una selezione
      if (this.output_PC === "DATEV") {
        const clientiIncompleti = this.vettoreClienti.some(
          (cliente) =>
            cliente[2] === 0 ||
            cliente[2] === "" ||
            cliente[2] === null ||
            cliente[2] === undefined
        );

        if (clientiIncompleti) {
          this.erroreModalMessaggio =
            "Specifica per ogni cliente se è un Azienda o un Libero Professionista prima di proseguire.";
          this.erroreModalVisibile = true;
          return;
        }
      }
      const clienti =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;

      let ciSonoMancanti = false;
      let ciSonoNonValidi = false;

      clienti.forEach((cliente) => {
        const codDitta = (cliente[0] || "").trim();
        const codiceFiscale = (cliente[4] || "").trim();

        // Codice Fiscale sempre obbligatorio.
        if (!codiceFiscale) {
          ciSonoMancanti = true;
        }

        if (codiceFiscale && !this.isValidCodiceFiscale(codiceFiscale)) {
          ciSonoNonValidi = true;
        }

        // Controllo codice ditta → obbligatorio SOLO se il flag è true
        if (this.settings.flag_mostra_codice_ditta && !codDitta) {
          ciSonoMancanti = true;
        }
      });

      // Errore sui CF non validi (indipendente dal flag)
      if (ciSonoNonValidi) {
        this.erroreModalMessaggio =
          "Alcuni Codici fiscali non sono validi.\n\n";
        this.erroreModalVisibile = true;
        return;
      }

      // Errore sui campi mancanti
      if (ciSonoMancanti) {
        if (this.settings.flag_mostra_codice_ditta) {
          // Caso classico: entrambi obbligatori
          this.erroreModalMessaggio =
            "Inserisci Codice ditta e Codice fiscale per tutti i clienti.";
        } else {
          // Solo CF obbligatorio
          this.erroreModalMessaggio =
            "Inserisci il Codice fiscale per tutti i clienti.";
        }

        this.erroreModalVisibile = true;
        return;
      }
      this.calculating2 = true;

      // Costruisci l'oggetto da inviare al backend
      const payload = {
        job_id: this.jobId,
        input_PC: this.input_PC,
        output_PC: this.output_PC,
        vettoreClienti: this.vettoreClienti,
        payment_dates: this.paymentDates,
        flag_saldoF24: this.settings.flag_saldoF24,
        confirm_registry_associations: registryConfirmed,
      };
      this.startDelayMessageTimer();
      // Effettua la richiesta HTTP al backend
      axios
        .post(`${API_BASE_URL}/conversione_f24_fase_2`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.clearDelayMessageTimer();
          this.jobId = response.data.job_id || this.jobId;
          this.codContoDefault =
            response.data.codContoDefault || this.codContoDefault;
          if (Array.isArray(response.data.vettoreCodTributo)) {
            this.vettoreCodTributo = this.normalizeF24PctRows(
              response.data.vettoreCodTributo
            );
          } else {
            this.vettoreCodTributo = [];
          }
          // === 2. vettoreCodTributoPCT + DEEP COPY ===
          if (Array.isArray(response.data.vettoreCodTributoPCT)) {
            this.vettoreCodTributoPCT = this.normalizeF24PctRows(
              response.data.vettoreCodTributoPCT
            );

            // SALVA LA COPIA ORIGINALE QUI!
            this.originalPCT = JSON.parse(
              JSON.stringify(this.vettoreCodTributoPCT)
            );

            console.log(
              "PCT caricato e originalPCT salvato:",
              this.originalPCT.length,
              "righe"
            );
          } else {
            this.vettoreCodTributoPCT = [];
            this.originalPCT = null; // Nessun PCT
          }
          this.pctGlobalRows = this.vettoreCodTributo;
          this.pctGlobalPdcRows = this.vettoreCodTributoPCT;
          this.pctGlobalOriginalPdcRows = JSON.parse(
            JSON.stringify(this.pctGlobalPdcRows || [])
          );
          this.pctClientGroups = this.normalizeF24PctClientGroups(
            response.data.pct_client_groups
          );
          this.pctClientOriginalGroups = JSON.parse(
            JSON.stringify(this.pctClientGroups)
          );
          this.pctClientTableMode = "all";
          this.selectedPctClientKey = "";
          this.vettoreClienti =
            response.data.vettoreClienti || this.vettoreClienti;
          this.bankCandidateGroups = response.data.vettoreCodSaldoFinale || [];
          this.vettoreCodSaldoFinale = initialBankSelection(
            this.bankCandidateGroups
          );
          if (Array.isArray(response.data.vettoreCodTributo9001)) {
            this.vettoreCodTributo9001 =
              response.data.vettoreCodTributo9001.map((row) =>
                Array.isArray(row)
                  ? row.map((cell, index) => {
                      if (
                        ([1, 2, 3, 4].includes(index) &&
                          (cell == null || cell === "None")) ||
                        this.isCodContoDefault(cell)
                      ) {
                        return null;
                      }
                      return cell;
                    })
                  : row
              );

            this.inputValues9001 = {};
            this.vettoreCodTributo9001.forEach((row, rowIndex) => {
              const mapped = this.mapped9001(rowIndex);
              mapped.forEach((val, colIndex) => {
                let cleanVal = val;
                if (cleanVal == null || cleanVal === "None") {
                  cleanVal = "";
                }
                // Imposta inputValues9001 solo per colonne editabili
                if ([6, 7, 8].includes(colIndex)) {
                  this.$set(
                    this.inputValues9001,
                    `${rowIndex}-${colIndex}`,
                    cleanVal
                  );
                }
              });
            });
          } else {
            // Fallback silenzioso: imposta array vuoto senza errore
            this.vettoreCodTributo9001 = [];
          }
          this.vettoreCodTributo9001_PCT = [];
          this.original9001PCT = null;
          this.vettore9001PCTVisible = false;
          console.log("vettore9001:");
          console.log(this.vettoreCodTributo9001);
          console.log("vettore9001PCT:");
          console.log(this.vettoreCodTributo9001_PCT);
          this.primeTableEditSession(
            "f24-main",
            "CODICI TRIBUTO INDIVIDUATI",
            this.vettoreCodTributo,
            true
          );
          this.primeTableEditSession(
            "f24-pct",
            "CODICI TRIBUTO GIÀ SALVATI",
            this.vettoreCodTributoPCT,
            true
          );
          this.primeTableEditSession(
            "f24-9001",
            "CODICI TRIBUTO 9001",
            this.vettoreCodTributo9001,
            true
          );
          this.primeTableEditSession(
            "f24-9001-pct",
            "CODICI TRIBUTO 9001 GIÀ SALVATI",
            this.vettoreCodTributo9001_PCT,
            true
          );
          this.primeTableEditSession(
            "f24-saldo",
            "COORDINATE BANCARIE",
            this.vettoreCodSaldoFinale,
            true
          );
          this.showF24Diagnostics(
            response.data.diagnostics_summary || this.diagnosticsSummary
          );
          this.selectFirstAvailableSubPhase();
          this.fase1 = false;
          this.fase2 = true;
          this.calculating2 = false;
        })
        .catch((error) => {
          this.clearDelayMessageTimer();
          if (isClientRegistryConfirmation(error)) {
            this.calculating2 = false;
            confirmClientRegistryAssociations(error, () => this.fase_2(true));
            return;
          }
          console.error("Errore nella conversione:", error);
          const backendMessage =
            error.response?.data?.error ||
            "Errore durante la conversione. Riprova o contatta l'assistenza.";
          const diagnosticsSummary =
            error.response?.data?.diagnostics_summary ||
            this.diagnosticsSummary;
          if (!this.showF24Diagnostics(diagnosticsSummary, backendMessage)) {
            this.erroreModalMessaggio = backendMessage;
            this.erroreModalVisibile = true;
          }
          this.calculating2 = false;
        });
    },

    fase_3() {
      if (this.shouldConfirmTableEditsBeforeConversion()) {
        this.openTableEditsConversionConfirm();
        return;
      }
      this.persistCurrentF24PctScope();
      if (!this.validateAllInputs()) return;
      if (this.needsF24Causale()) {
        this.openF24CausaleModal({ retryAfterSave: true });
        return;
      }

      const pctClientGroups = this.buildF24ClientPctUpdates();
      const pctRowsToValidate = {
        custom: [
          { client_key: "piano globale", rows: this.pctGlobalRows || [] },
          ...(pctClientGroups.custom || []),
        ],
        custom_pdc: [
          ...(this.f24PctRowsChanged(
            this.pctGlobalPdcRows,
            this.pctGlobalOriginalPdcRows
          )
            ? [
                {
                  client_key: "piano globale",
                  rows: this.pctGlobalPdcRows || [],
                },
              ]
            : []),
          ...(pctClientGroups.custom_pdc || []),
        ],
      };
      if (!this.validateF24ClientPctUpdates(pctRowsToValidate)) return;
      this.finalConversionInProgress = true;
      this.calculating2 = true;

      const validColumns = this.getValidColumns();

      // === 1. Prepara vettore principale F24 ===
      let finalVector = (this.pctGlobalRows || []).map((row) =>
        row
          .map((cell, index) => (validColumns.includes(index) ? cell : null))
          .slice(0, -2)
      );

      // === 2. Unisci PCT SOLO se MODIFICATO ===
      if (
        this.f24PctRowsChanged(
          this.pctGlobalPdcRows,
          this.pctGlobalOriginalPdcRows
        ) &&
        this.pctGlobalPdcRows?.length > 0
      ) {
        const pctValidCols = this.validColumnsPCT || validColumns;
        const pctRows = this.pctGlobalPdcRows.map((row) =>
          row
            .map((cell, index) => (pctValidCols.includes(index) ? cell : null))
            .slice(0, -2)
        );
        finalVector = [...finalVector, ...pctRows];
        console.log("PCT MODIFICATO → aggiunte", pctRows.length, "righe");
      } else {
        console.log("PCT NON MODIFICATO → ignorato");
      }

      console.log("VETTORE FINALE F24 (unificato):", finalVector);

      this.flag_output_std = !this.flag_csv_import;

      // Conferma tutte le proposte, conservando software, piano DATEV e data.
      const finalVector9001 = this.vettoreCodTributo9001.map((row) => [...row]);
      // === 4. Payload con UNICI vettori F24 e 9001 ===
      const payload = {
        job_id: this.jobId,
        output_PC: this.output_PC,
        vettoreClienti: this.vettoreClienti,
        flag_output_std: this.flag_output_std,
        flag_overall: this.isExtendedVersion,
        vettoreCodTributo: finalVector, // UNICO vettore F24
        vettoreCodSaldoFinale: this.vettoreCodSaldoFinale,
        vettoreCodTributo9001: finalVector9001, // UNICO vettore 9001 unificato
        flag_accorpato: this.settings.flag_accorpato,
        causale: this.causaleModelliF24 || null,
        pct_client_groups: pctClientGroups,
      };

      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/conversione_f24_fase_3`, payload, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          this.clearDelayMessageTimer();
          this.naConfirmed = false;

          if (res.data.success && res.data.job) {
            this.hasDownloaded = false;
            this.applyJobState(res.data.job);
            this.startJobPolling();
          } else {
            this.errorMessage = res.data.error || "Errore dal backend";
            this.calculating2 = false;
            this.finalConversionInProgress = false;
          }
        })
        .catch((err) => {
          this.clearDelayMessageTimer();
          this.errorMessage =
            err.response?.data?.error ||
            "Errore di comunicazione con il server";
          this.calculating2 = false;
          this.finalConversionInProgress = false;
          console.error(err);
        });
    },
    nextConversionStep() {
      this.isShifted = true;
      this.showResult = true;
      return this.$nextTick().then(
        () =>
          new Promise((resolve) => {
            setTimeout(resolve, 720);
          })
      );
    },
    async refreshConversione() {
      if (this.shouldConfirmReset()) {
        this.openConversionInterruptModal("reset");
        return;
      }
      if (this.jobId) {
        if (this.isPollableJobStatus(this.jobStatus)) {
          await this.cancelActiveJob(false);
        } else {
          await this.cleanupSpecificJob(this.jobId);
          await this.cleanupPurgeableJobs();
        }
      }
      this.resetConversione();
    },
    async confirmResetDuringJob() {
      const context = this.resetConfirmContext;
      const routeNext = this.pendingRouteLeaveNext;
      const routeTarget = this.pendingRouteLeaveTarget;
      const isCompletedOutputPending = this.hasUndownloadedCompletedOutput();
      this.showResetConfirmModal = false;
      this.isResettingConversion = true;
      const resetStartedAt = Date.now();
      try {
        if (isCompletedOutputPending) {
          if (this.jobId) {
            await this.cleanupSpecificJob(this.jobId);
            await this.cleanupPurgeableJobs();
          }
          this.clearJobState();
        } else {
          await this.cancelActiveJob(false);
        }
        await this.waitForResetOverlayMinimum(resetStartedAt);
        if (context === "leave" && routeTarget) {
          this.$router.push(routeTarget);
        } else if (context === "leave" && routeNext) {
          routeNext();
        } else {
          this.resetConversione();
          await this.$nextTick();
          await this.wait(40);
        }
      } finally {
        this.isResettingConversion = false;
        this.pendingRouteLeaveNext = null;
        this.pendingRouteLeaveTarget = null;
        this.resetConfirmContext = "reset";
      }
    },
    resetConversione() {
      setTimeout(() => {
        this.isShifted = false; // Rimuove il "shift" per tornare alla posizione iniziale
      }, 10); // Il delay di 10ms è per permettere alla transizione di essere applicata
      // Resetta il file input
      if (this.filePDF_URL) {
        URL.revokeObjectURL(this.filePDF_URL);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      this.showResult = false;
      this.fase0 = true;
      this.fase1 = false;
      this.fase2 = false;
      this.fase3 = false;
      this.selectedFile = null;
      this.filePDF_URL = null;
      this.fileTitle = null;
      this.ExcelRows = [];
      this.fileType = "";
      this.excelPath = null;
      this.mergedOverall = null;
      this.filePath = null;
      this.showPDF = false;
      this.showExcelModal = false;
      this.input_PC = "";
      this.errorMessage = "";
      this.flag_csv_import = false;
      this.flag_output_std = false;
      this.isExtendedVersion = false;
      this.vettoreClienti = [];
      this.vettoreCodTributo = [];
      this.vettoreCodTributoPCT = [];
      this.pctGlobalRows = [];
      this.pctGlobalPdcRows = [];
      this.pctGlobalOriginalPdcRows = [];
      this.pctClientGroups = {
        global: [],
        global_pdc: [],
        custom: [],
        custom_pdc: [],
        non_custom: [],
        non_custom_pdc: [],
      };
      this.pctClientOriginalGroups = null;
      this.pctClientTableMode = "all";
      this.selectedPctClientKey = "";
      this.diagnosticsSummary = null;
      this.conversionDiagnosticsModal = {
        visible: false,
        summary: null,
        rootSummary: null,
        notificationQueue: [],
        notificationIndex: 0,
        backendMessage: "",
      };
      this.originalPCT = null;
      this.vettoreCodTributo9001 = [];
      this.vettoreCodTributo9001_PCT = [];
      this.original9001PCT = null;
      this.vettoreCodSaldoFinale = [];
      this.bankCandidateGroups = [];
      this.paymentDates = [];
      this.inputValues9001 = {};
      this.editableCells = new Set();
      this.confermaConversione = false;
      this.hasDownloaded = false;
      this.hasOutputDownloadStarted = false;
      this.editingAbiCab = {};
      this.editingDate = {};
      this.inputValues = {};
      this.errorsData = [];
      this.isEditMode = false;
      this.isEditModePCT = false;
      this.isEditMode9001PCT = false;
      this.isEditMode9001 = false;
      this.isEditModeSaldoFinale = false;
      this.clearAllTableEditSessions();
      this.vettorePCTVisible = false;
      this.vettore9001PCTVisible = false;
      this.isTableExpanded = false;
      this.isTableTributoPCTExpanded = false;
      this.isTable9001Expanded = false;
      this.isTable9001PCTExpanded = false;
      this.isTableSaldoExpanded = false;
      this.currentSubPhase = "A";
      this.showErrorModal = false;
      this.erroreModalVisibile = false;
      this.erroreModalMessaggio = "";
      this.naConfirmed = false;
      this.noCorrConfirmed = false;
      this.showCoinPurchase = false;
      this.clearDelayMessageTimer();
      this.clearJobState();
      this.loadSettings();
    },
    async fetchClients() {
      try {
        const response = await axios.get(`${API_BASE_URL}/vettore_datev`);
        this.vettoreClienti = response.data;
      } catch (error) {
        console.error("Errore nel recupero dei clienti:", error);
      }
    },
    getMergedOverall() {
      if (!this.jobId) return;
      axios
        .get(`${API_BASE_URL}/merged_overall`, {
          params: { job_id: this.jobId },
          responseType: "arraybuffer", // Importante per dati binari
        })
        .then((response) => {
          const data = new Uint8Array(response.data); // Converte i dati in array di byte
          const workbook = XLSX.read(data, { type: "array" }); // Legge il file Excel
          const firstSheetName = workbook.SheetNames[0]; // Prende il nome del primo foglio
          const worksheet = workbook.Sheets[firstSheetName];

          // Converte i dati del foglio in JSON e li salva in mergedOverall
          this.mergedOverall = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
          // Normalizza le righe per avere lo stesso numero di colonne
          const maxColumns = this.mergedOverall[0].length;
          this.mergedOverall.forEach((row) => {
            while (row.length < maxColumns) {
              row.push(""); // Aggiunge celle vuote se mancano
            }
          });
          this.mergedOverall[0].push(""); // Aggiunge un header vuoto per la colonna del cestino
        })
        .catch((error) => {
          console.error("Errore nel caricamento di Merged Overall:", error);
        });
    },
    isBilancino(row) {
      return row[1] === undefined || row[1] === ""; // Se la seconda colonna è vuota, è un bilancino
    },
    handleFileChange(event) {
      // If we're restoring, skip processing to avoid infinite loop
      if (this.restoringFile) {
        this.restoringFile = false;
        // Check if files were cleared unexpectedly and reapply restoration
        if (this.selectedFile && !this.$refs.fileInput.files.length) {
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
          });
        }
        return;
      }

      const newFile = event.target.files[0];

      // Detect cancel: files.length === 0 (browser cleared it)
      if (!newFile) {
        if (this.selectedFile) {
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
            this.restoringFile = true; // Set flag for potential change event
            this.fileTitle = this.selectedFile.name; // Ensure fileTitle is in sync
          });
        } else {
          this.fileTitle = "Nessun file selezionato";
        }
        return;
      }
      const previousFile = this.selectedFile;
      const isSameFile =
        previousFile &&
        previousFile.name === newFile.name &&
        previousFile.lastModified === newFile.lastModified;

      if (isSameFile) {
        this.inputPcEditable = false;
        this.fileTitle = previousFile.name;
        return;
      }

      if (previousFile) {
        this.resetConversione();
        if (this.$refs.fileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(newFile);
          this.$refs.fileInput.files = dataTransfer.files;
        }
      }

      this.errorMessage = "";

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Set fileType per distinguere CSV da Excel
      if (estensione === "csv") {
        this.fileType = "csv";
      } else if (["xls", "xlsx", "xlsm"].includes(estensione)) {
        this.fileType = "excel";
      } else {
        this.fileType = "";
      }

      // Se il file è un PDF, genera l'URL per visualizzazione
      if (newFile.type === "application/pdf") {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = URL.createObjectURL(newFile);
      } else {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = null;
      }

      // Gestione primo caricamento o file diverso
      if (!this.selectedFile) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.fileTitle = this.selectedFile.name;
        this.leggiFileExcelOCsv(newFile, estensione);
        return;
      }

      // Controlla se è cambiato il file selezionato
      if (
        this.selectedFile.name !== newFile.name ||
        this.selectedFile.lastModified !== newFile.lastModified
      ) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.resetConversione();
        this.leggiFileExcelOCsv(newFile, estensione);
      } else {
        this.inputPcEditable = false;
      }

      this.fileTitle = this.selectedFile.name;
    },
    leggiFileExcelOCsv(file, estensione) {
      if (estensione === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const testoCsv = e.target.result;
          this.ExcelRows = testoCsv.split("\n").map((line) => line.split(","));
        };
        reader.readAsText(file);
      } else if (estensione === "xls" || estensione === "xlsx") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.ExcelRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.ExcelRows = [];
        this.fileType = "";
      }
    },
    openPDFPreview() {
      this.showPDF = true;
    },
    cleanbackend() {},
    getValidColumns() {
      // Mappa delle colonne da escludere in base a output_PC
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };

      // Ottieni gli indici da escludere per il valore attuale di output_PC
      const excludedColumns = excludedColumnsMap[this.output_PC] || [];

      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excludedColumns.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }

      // Restituisci solo gli indici che non sono da escludere
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excludedColumns.includes(index));
    },
    isEditableColumnPCT(originalIndex, rowIndex) {
      // Escludi esplicitamente originalIndex === 0 (Codice Tributo)
      if (originalIndex === 0) {
        return false;
      }

      // Rendi editabile solo se isEditModePCT è attivo
      if (!this.isEditModePCT) {
        return false;
      }

      const cellKey = rowIndex + "-" + originalIndex;
      const currentRow =
        this.vettoreCodTributoPCT && this.vettoreCodTributoPCT[rowIndex];

      // Clear "Descrizione - Cod. Conto Default" proactively (solo in edit mode)
      if (
        currentRow &&
        currentRow[originalIndex] === "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributoPCT[rowIndex][originalIndex] = "";
        this.editableCells.add(cellKey); // Mark as editable after clearing
      }

      // Controlla se la colonna è una "Descrizione Cod. Conto"
      const isNomeConto = this.isDescrizioneCodContoColumn(
        this.headers[originalIndex]
      );

      // Logica per le colonne "Descrizione Cod. Conto": editabile in edit mode, o se marcata
      if (isNomeConto) {
        return true; // Sempre editabile in edit mode
        // Oppure, se vuoi mantenere condizioni extra: return true || this.editableCells.has(cellKey);
      }

      // Logica per altre colonne editabili in base a output_PC (ora solo in edit mode)
      if (this.editableCells.has(cellKey)) {
        return true;
      }

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 2 || originalIndex === 3; // Cod. conto DARE/AVERE TeamSystem
        case "DATEV":
          return [5, 6, 8, 9].includes(originalIndex); // Cod. conto DARE/AVERE Datev
        case "ZUCCHETTI":
          return [11, 12].includes(originalIndex); // Cod. conto DARE/AVERE Zucchetti
        case "SEAC":
          return [14, 15].includes(originalIndex); // Cod. conto DARE/AVERE SEAC
        case "SISTEMI":
          return [17, 18].includes(originalIndex); // Cod. conto DARE/AVERE Sistemi
        default:
          return false;
      }
    },
    isEditableColumn(originalIndex, rowIndex) {
      // Escludi esplicitamente originalIndex === 0 (Codice Tributo)
      if (originalIndex === 0) {
        return false;
      }

      const cellKey = rowIndex + "-" + originalIndex;
      const currentRow =
        this.vettoreCodTributo && this.vettoreCodTributo[rowIndex];

      // Clear "Descrizione - Cod. Conto Default" proactively
      if (
        currentRow &&
        currentRow[originalIndex] === "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributo[rowIndex][originalIndex] = "";
        this.editableCells.add(cellKey); // Mark as editable after clearing
      }

      // Controlla se la colonna è una "Descrizione Cod. Conto"
      const isNomeConto = this.isDescrizioneCodContoColumn(
        this.headers[originalIndex]
      );

      // Logica per le colonne "Descrizione Cod. Conto"
      if (isNomeConto) {
        return (
          this.isEditMode ||
          !currentRow[originalIndex] ||
          this.editableCells.has(cellKey)
        );
      }

      // Logica per altre colonne editabili in base a output_PC
      if (this.editableCells.has(cellKey)) {
        return true;
      }

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 2 || originalIndex === 3; // Cod. conto DARE/AVERE TeamSystem
        case "DATEV":
          return [5, 6, 8, 9].includes(originalIndex); // Cod. conto DARE/AVERE Datev
        case "ZUCCHETTI":
          return [11, 12].includes(originalIndex); // Cod. conto DARE/AVERE Zucchetti
        case "SEAC":
          return [14, 15].includes(originalIndex); // Cod. conto DARE/AVERE SEAC
        case "SISTEMI":
          return [17, 18].includes(originalIndex); // Cod. conto DARE/AVERE Sistemi
        default:
          return false;
      }
    },
    toggleEditMode() {
      this.toggleTableEditSession(
        "f24-main",
        "CODICI TRIBUTO INDIVIDUATI",
        this.vettoreCodTributo
      );
      this.isEditMode = this.isTableEditing("f24-main");
    },
    toggleEditModePCT() {
      this.toggleTableEditSession(
        "f24-pct",
        "CODICI TRIBUTO GIÀ SALVATI",
        this.vettoreCodTributoPCT
      );
      this.isEditModePCT = this.isTableEditing("f24-pct");
    },
    toggleCurrentF24CodTributoExpansion() {
      if (this.vettorePCTVisible) {
        this.toggleTableTributoPCTExpansion();
      } else {
        this.toggleTableExpansion();
      }
    },
    toggleCurrentF24CodTributoEditMode() {
      if (!this.canUseCurrentF24CodTributoEdit) return;
      if (this.vettorePCTVisible) {
        this.toggleEditModePCT();
      } else {
        this.toggleEditMode();
      }
    },
    saveCurrentF24CodTributoTable() {
      if (!this.currentF24CodTributoHasChanges) return;
      this.saveF24Table(
        this.currentF24CodTributoTableKey,
        this.currentF24CodTributoRows
      );
    },
    undoCurrentF24CodTributoTable() {
      if (!this.currentF24CodTributoCanUndo) return;
      this.undoF24Table(
        this.currentF24CodTributoTableKey,
        this.currentF24CodTributoRows
      );
    },
    resetCurrentF24CodTributoTable() {
      if (!this.currentF24CodTributoHasChanges) return;
      this.resetF24Table(
        this.currentF24CodTributoTableKey,
        this.vettorePCTVisible ? "vettoreCodTributoPCT" : "vettoreCodTributo"
      );
    },
    toggleCurrentF249001Expansion() {
      if (this.vettore9001PCTVisible) {
        this.toggleTable9001PCTExpansion();
      } else {
        this.toggleTable9001Expansion();
      }
    },
    saveCurrentF249001Table() {
      if (!this.currentF249001HasChanges) return;
      this.saveF24Table(this.currentF249001TableKey, this.currentF249001Rows);
    },
    undoCurrentF249001Table() {
      if (!this.currentF249001CanUndo) return;
      this.undoF24Table(this.currentF249001TableKey, this.currentF249001Rows);
    },
    resetCurrentF249001Table() {
      if (!this.currentF249001HasChanges) return;
      this.resetF24Table(
        this.currentF249001TableKey,
        this.currentF249001TableName
      );
    },
    saveCurrentF24SaldoTable() {
      if (!this.currentF24SaldoHasChanges) return;
      this.saveF24Table("f24-saldo", this.vettoreCodSaldoFinale);
    },
    undoCurrentF24SaldoTable() {
      if (!this.currentF24SaldoCanUndo) return;
      this.undoF24Table("f24-saldo", this.vettoreCodSaldoFinale);
    },
    resetCurrentF24SaldoTable() {
      if (!this.currentF24SaldoHasChanges) return;
      this.resetF24Table("f24-saldo", "vettoreCodSaldoFinale");
    },
    toggleEditMode9001() {
      this.toggleTableEditSession(
        "f24-9001",
        "CODICI TRIBUTO 9001",
        this.vettoreCodTributo9001
      );
      this.isEditMode9001 = this.isTableEditing("f24-9001");
    },
    toggleEditMode9001PCT() {
      this.toggleTableEditSession(
        "f24-9001-pct",
        "CODICI TRIBUTO 9001 GIÀ SALVATI",
        this.vettoreCodTributo9001_PCT
      );
      this.isEditMode9001PCT = this.isTableEditing("f24-9001-pct");
    },
    toggleEditModeSaldoFinale() {
      this.toggleTableEditSession(
        "f24-saldo",
        "COORDINATE BANCARIE",
        this.vettoreCodSaldoFinale
      );
      this.isEditModeSaldoFinale = this.isTableEditing("f24-saldo");
    },
    handleF24CellInput(tableKey, rowIndex, colIndex, realColIndex, vettore) {
      this.validateInput(rowIndex, colIndex, vettore);
      this.trackTableCellChange(
        tableKey,
        rowIndex,
        realColIndex,
        vettore[rowIndex][realColIndex],
        vettore,
        tableKey === "f24-pct"
          ? "CODICI TRIBUTO GIÀ SALVATI"
          : "CODICI TRIBUTO INDIVIDUATI"
      );
      this.propagateF24GlobalPctRowsToClientGroups(tableKey, vettore);
    },
    saveF24Table(tableKey, vettore) {
      this.markCurrentF24ClientRowsAsSaved(tableKey);
      this.commitTableEditSession(tableKey, vettore);
      this.propagateF24GlobalPctRowsToClientGroups(tableKey, vettore);
      if (tableKey === "f24-main") this.isEditMode = false;
      if (tableKey === "f24-pct") this.isEditModePCT = false;
      if (tableKey === "f24-9001") this.isEditMode9001 = false;
      if (tableKey === "f24-9001-pct") this.isEditMode9001PCT = false;
      if (tableKey === "f24-saldo") this.isEditModeSaldoFinale = false;
    },
    undoF24Table(tableKey, vettore) {
      this.undoLastTableChange(tableKey, ({ rowIndex, colIndex, oldValue }) => {
        this.$set(vettore[rowIndex], colIndex, oldValue);
        this.propagateF24GlobalPctRowsToClientGroups(tableKey, vettore);
        if (tableKey === "f24-9001" || tableKey === "f24-9001-pct") {
          const prefix = tableKey === "f24-9001-pct" ? "pct-" : "";
          const mappedIndex = { 4: 6, 5: 7, 6: 8 }[colIndex];
          if (mappedIndex !== undefined) {
            this.$set(
              this.inputValues9001,
              `${prefix}${rowIndex}-${mappedIndex}`,
              oldValue
            );
          }
        }
        if (tableKey === "f24-saldo") {
          const mapped = this.mappedSaldoFinale(rowIndex);
          this.validColumns2.forEach((visibleColIndex) => {
            this.$set(
              this.inputValues,
              `${rowIndex}-${visibleColIndex}`,
              mapped[visibleColIndex] || ""
            );
          });
        }
      });
    },
    resetF24Table(tableKey, tableName) {
      if (!this.hasTableChanges(tableKey)) return;
      const label = this.tableEditSessions[tableKey]?.label || "questa tabella";
      this.pendingTableReset = { tableKey, tableName };
      this.resetConfirmContext = "table-reset";
      this.resetConfirmTitle = "Annullare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche tabella";
      this.resetConfirmMessage = `Le modifiche non salvate in ${label} verranno eliminate. Vuoi continuare?`;
      this.resetConfirmConfirmLabel = "Annulla modifiche";
      this.resetConfirmCancelLabel = "Mantieni modifiche";
      this.resetConfirmIconClass = "fa-solid fa-rotate-left";
      this.resetConfirmConfirmIconClass = "fa-solid fa-rotate-left";
      this.showResetConfirmModal = true;
    },
    confirmResetF24Table() {
      if (!this.pendingTableReset) return;
      const { tableKey, tableName } = this.pendingTableReset;
      this.resetTableEditSession(tableKey, tableName, (restored) => {
        if (tableKey === "f24-main" || tableKey === "f24-pct") {
          this.propagateF24GlobalPctRowsToClientGroups(tableKey, restored);
        }
        if (tableKey === "f24-9001" || tableKey === "f24-9001-pct") {
          this.rebuildInputValues9001(tableKey, restored);
        }
        if (tableKey === "f24-saldo") {
          this.rebuildSaldoInputValues(restored);
        }
      });
      this.pendingTableReset = null;
    },
    handle9001CellInput(tableKey, rowIndex, colIndex, event, vettoreTarget) {
      this.validateInput9001(rowIndex, colIndex, event, vettoreTarget);
      const realColIndex = { 6: 4, 7: 5, 8: 6 }[colIndex];
      if (realColIndex !== undefined) {
        this.trackTableCellChange(
          tableKey,
          rowIndex,
          realColIndex,
          vettoreTarget[rowIndex][realColIndex],
          vettoreTarget,
          tableKey === "f24-9001-pct"
            ? "CODICI TRIBUTO 9001 GIÀ SALVATI"
            : "CODICI TRIBUTO 9001"
        );
      }
    },
    handleSaldoCellInput(rowIndex, colIndex, event) {
      this.validateInputSaldoFinale(rowIndex, colIndex, event);
      const realColIndex = this.getSaldoRealColIndex(colIndex);
      if (realColIndex !== null) {
        this.trackTableCellChange(
          "f24-saldo",
          rowIndex,
          realColIndex,
          this.vettoreCodSaldoFinale[rowIndex][realColIndex],
          this.vettoreCodSaldoFinale,
          "COORDINATE BANCARIE"
        );
      }
    },
    getSaldoRealColIndex(colIndex) {
      if (colIndex === 2 || colIndex === 3) return 2;
      if (colIndex === 4) return 3;
      if (colIndex === 5) {
        return (
          { TEAMSYSTEM: 4, DATEV: 7, ZUCCHETTI: 13, SEAC: 16, SISTEMI: 19 }[
            this.output_PC
          ] ?? null
        );
      }
      if (colIndex === 6 && this.output_PC === "TEAMSYSTEM") return 6;
      if (colIndex === 7 && this.output_PC === "DATEV") return 9;
      if (colIndex === 8 && this.output_PC === "DATEV") return 12;
      if (colIndex === 9 && this.output_PC === "ZUCCHETTI") return 15;
      if (colIndex === 10 && this.output_PC === "SEAC") return 18;
      if (colIndex === 11 && this.output_PC === "SISTEMI") return 21;
      return null;
    },
    normalizeSaldoDisplayValue(colIndex, value) {
      if (
        value == null ||
        value === "None" ||
        value === "VUOTO" ||
        ((colIndex === 2 || colIndex === 3) && this.isCodContoDefault(value)) ||
        ((colIndex === 2 || colIndex === 3) && value === "00000") ||
        (colIndex === 4 && value === "01/01/1970")
      ) {
        return "";
      }
      return value;
    },
    isSaldoCellDirty(rowIndex, colIndex) {
      if (colIndex === 2 || colIndex === 3) {
        const baselineRow =
          this.tableEditSessions?.["f24-saldo"]?.baseline?.[rowIndex];
        if (!baselineRow) return false;
        const currentValue = this.normalizeSaldoDisplayValue(
          colIndex,
          this.mappedSaldoFinale(rowIndex)[colIndex]
        );
        const baselineValue = this.normalizeSaldoDisplayValue(
          colIndex,
          this.mappedSaldoFinaleFromRow(baselineRow)[colIndex]
        );
        return currentValue !== baselineValue;
      }

      const realColIndex = this.getSaldoRealColIndex(colIndex) ?? colIndex;
      return this.isTableCellDirty("f24-saldo", rowIndex, realColIndex);
    },
    saldoCellEditClasses(rowIndex, colIndex, invalid = false) {
      const dirty = this.isSaldoCellDirty(rowIndex, colIndex);
      return {
        "cell-error": invalid,
        "error-cell": invalid,
        "modified-cell": dirty && !invalid,
      };
    },
    saldoCellDisplayClasses(rowIndex, colIndex, invalid = false) {
      const dirty = this.isSaldoCellDirty(rowIndex, colIndex);
      return {
        "cell-display-state": dirty || invalid,
        "cell-display-modified": dirty && !invalid,
        "cell-display-error": invalid,
      };
    },
    rebuildInputValues9001(tableKey, rows) {
      const prefix = tableKey === "f24-9001-pct" ? "pct-" : "";
      rows.forEach((row, rowIndex) => {
        const mapped = this.mapped9001(rowIndex, rows);
        this.validColumns9001.forEach((colIndex) => {
          if (colIndex === 6 || colIndex === 7 || colIndex === 8) {
            this.$set(
              this.inputValues9001,
              `${prefix}${rowIndex}-${colIndex}`,
              mapped[colIndex]
            );
          }
        });
      });
    },
    rebuildSaldoInputValues(rows) {
      rows.forEach((row, rowIndex) => {
        const mapped = this.mappedSaldoFinaleFromRow(row);
        this.validColumns2.forEach((colIndex) => {
          this.$set(
            this.inputValues,
            `${rowIndex}-${colIndex}`,
            this.normalizeSaldoDisplayValue(colIndex, mapped[colIndex])
          );
        });
      });
    },
    mappedSaldoFinaleFromRow(row) {
      if (!row || row.length < 22) return [];
      const [cf = "", abi = "", cab = ""] = String(row[2] || "").split("-");
      const values = {
        TEAMSYSTEM: [row[4], row[6], "", "", "", "", ""],
        DATEV: [row[7], "", row[9], row[12], "", "", ""],
        ZUCCHETTI: [row[13], "", "", "", row[15], "", ""],
        SEAC: [row[16], "", "", "", "", row[18], ""],
        SISTEMI: [row[19], "", "", "", "", "", row[21]],
      }[this.output_PC] || ["", "", "", "", "", "", ""];
      return [row[1], cf, abi, cab, row[3], ...values];
    },
    isF24CellInvalid(rowIndex, colIndex, vettore) {
      const isPCT = vettore === this.vettoreCodTributoPCT;
      const columns = isPCT ? this.validColumnsPCT : this.validColumns;
      const realColIndex = columns[colIndex];
      const columnName = this.headers[realColIndex];
      return !this.isF24CodeValueValid(
        columnName,
        vettore?.[rowIndex]?.[realColIndex]
      );
    },
    isF24CodeValueValid(columnName, value) {
      const str =
        value === null || value === undefined ? "" : String(value).trim();
      if (!str || str === "N.A." || str === "NESSUNA CORRELAZIONE") return true;
      if (this.isCodContoDefault(str)) return false;
      const normalizedName = String(columnName || "").toLowerCase();
      if (
        !columnName ||
        normalizedName.includes("descrizione") ||
        !normalizedName.includes("cod.")
      ) {
        return true;
      }
      if (normalizedName.includes("teamsystem"))
        return /^\d{2}\/\d{2}\/\d{3}$/.test(str);
      if (normalizedName.includes("sistemi"))
        return /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(str);
      if (normalizedName.includes("seac")) return /^\d{6}$/.test(str);
      return /^\d+$/.test(str);
    },
    is9001CellInvalid(rowIndex, colIndex, vettore) {
      if (![7, 8].includes(colIndex)) return false;
      const value = this.mapped9001(rowIndex, vettore)[colIndex];
      return !this.isF24CodeValueValid(`Cod. Conto - ${this.output_PC}`, value);
    },
    isSaldoCellInvalid(rowIndex, colIndex) {
      const value = this.mappedSaldoFinale(rowIndex)[colIndex];
      if (colIndex === 2 || colIndex === 3) {
        return Boolean(value) && !/^\d{5}$/.test(String(value));
      }
      if (colIndex === 4) {
        return Boolean(value) && !/^\d{2}\/\d{2}\/\d{4}$/.test(String(value));
      }
      if (colIndex >= 6) {
        return !this.isF24CodeValueValid(
          `Cod. Conto - ${this.output_PC}`,
          value
        );
      }
      return false;
    },
    clearDefaultDescription(rowIndex, colIndex) {
      if (
        this.vettoreCodTributo[rowIndex][colIndex] ===
        "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributo[rowIndex][colIndex] = "";
      }
    },
    // @focus="clearDefaultDescription(rowIndex, col)"
    // @focus="
    //                             clearDefaultDescription(rowIndex, realColIndex)
    //                           "
    // @focus="
    //                             colIndex === 6
    //                               ? clearDefaultDescription(rowIndex, colIndex)
    //                               : null
    //                           "
    isDescrizioneCodContoColumn(headerName) {
      const nomeContoLabels = [
        "Descrizione Cod. Conto",
        "Descrizione Cod. Conto - Datev Aziende",
        "Descrizione Cod. Conto - Datev Lib. Prof.",
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
        "Descrizione - Cod. Conto Default",
      ];
      return nomeContoLabels.includes(headerName);
    },
    commitAbiCabInputs() {
      for (const key in this.inputValues) {
        const [rowIndex, colIndex] = key.split("-").map(Number);
        if (colIndex === 2 || colIndex === 3) {
          let value = this.inputValues[key]
            .toString()
            .replace(/[^0-9]/g, "")
            .slice(0, 5);
          this.updateMappedCell(rowIndex, colIndex, value);
        }
      }
    },
    commitOtherInputs() {
      for (const key in this.inputValues) {
        const [rowIndex, colIndex] = key.split("-").map(Number);
        if (colIndex !== 2 && colIndex !== 3) {
          let value = this.inputValues[key];
          this.updateMappedCell(rowIndex, colIndex, value);
        }
      }
    },
    mapped9001(rowIndex, vettore = this.vettoreCodTributo9001) {
      const row = vettore?.[rowIndex];
      if (!row) return Array(9).fill(""); // ritorna array vuoto se non c'è riga
      const dateFull = row[9] || "";
      const dateTrimmed = numericPaymentDate(dateFull);
      return [
        row[0] || "", // Denominazione Cliente
        row[1] || "", // C.F. Cliente
        dateTrimmed, // Data Pagamento
        "9001", // Codice Tributo
        row[2] || "0,00", // Saldo DARE
        row[3] || "0,00", // Saldo AVERE
        row[4] || null, // Descrizione Cod. Conto
        row[5] || null, // Cod. Conto DARE
        row[6] || null, // Cod. Conto AVERE
      ];
    },
    get9001RealColIndex(colIndex) {
      return (
        {
          0: 0,
          1: 1,
          2: 9,
          4: 2,
          5: 3,
          6: 4,
          7: 5,
          8: 6,
        }[colIndex] ?? `visible-${colIndex}`
      );
    },
    isEditable9001(colIndex, tableKey = "f24-9001") {
      if (![6, 7, 8].includes(colIndex)) return false;
      if (tableKey === "f24-9001-pct") return true;
      return true;
    },
    validateInput9001(rowIndex, colIndex, event, vettoreTarget) {
      const isSaved9001 = vettoreTarget === this.vettoreCodTributo9001_PCT;
      const inputKey = isSaved9001
        ? `pct-${rowIndex}-${colIndex}`
        : `${rowIndex}-${colIndex}`;
      let value = event.target.value;

      // Solo per le colonne Cod. Conto DARE e AVERE (7 e 8)
      if (colIndex === 7 || colIndex === 8) {
        // Copia la logica di validazione già esistente
        const onlyLetters = value.replace(/[^a-zA-Z]/g, "").toLowerCase();

        if (onlyLetters === "na") {
          const numbers = value.replace(/\D/g, "");
          if (numbers.length > 0) {
            value = numbers; // se c'è almeno un numero → continua con quello
          } else {
            value = "N.A."; // altrimenti resta N.A.
          }
        }
        // Se contiene lettere (e non è N.A.) → forza "N.A."
        else if (/[a-zA-Z]/.test(value)) {
          value = "N.A.";
        } else {
          // Solo numeri → applichiamo le regole in base al nome colonna
          value = value.replace(/\D/g, "");

          // TEAMSYSTEM
          if (this.output_PC === "TEAMSYSTEM") {
            // Formato 99/99/999
            if (value.length > 2)
              value = value.slice(0, 2) + "/" + value.slice(2);
            if (value.length > 5)
              value = value.slice(0, 5) + "/" + value.slice(5);
            value = value.slice(0, 9);
          }
          // SISTEMI
          else if (this.output_PC === "SISTEMI") {
            // xxx.xx.xxxx
            if (value.length > 2)
              value = value.slice(0, 2) + "." + value.slice(2);
            if (value.length > 5)
              value = value.slice(0, 5) + "." + value.slice(5);
            if (value.length > 8)
              value = value.slice(0, 8) + "." + value.slice(8);
            value = value.slice(0, 12);
          }
          // SEAC
          else if (this.output_PC === "SEAC") {
            value = value.slice(0, 6);
          }
          // Datev / Zucchetti → solo numeri, nessun formato particolare
          else if (
            this.output_PC === "DATEV" ||
            this.output_PC === "ZUCCHETTI"
          ) {
            if (this.output_PC === "DATEV") value = value.slice(0, 11);
            // value rimane solo numeri
          }
          // Default: solo numeri senza limiti particolari
          else {
            // value rimane solo numeri
          }
        }
      }

      // Aggiorna il valore nell'input
      event.target.value = value;

      // Salva nei valori temporanei e nel vettore mappato
      this.$set(this.inputValues9001, inputKey, value);
      this.updateMapped9001(rowIndex, colIndex, value, vettoreTarget);
    },
    updateMapped9001(rowIndex, colIndex, value, vettoreTarget) {
      const row = vettoreTarget[rowIndex];
      if (!row) return;
      switch (colIndex) {
        case 2:
          row[9] = value;
          break; // Data Pagamento
        case 6:
          row[4] = value;
          break; // Descrizione
        case 7:
          row[5] = value;
          break; // Cod. Conto DARE
        case 8:
          row[6] = value; // Cod. Conto AVERE
          break;
      }
    },
    mappedSaldoFinale(rowIndex) {
      const row = this.vettoreCodSaldoFinale[rowIndex];
      if (!row || row.length < 22) return [];
      const [cf = "", abi = "", cab = ""] = String(row[2] || "").split("-");
      let denominazione = row[1];
      let nomeConto = "";
      let data = row[3];
      let ts = "",
        daAz = "",
        daLp = "",
        zuc = "",
        seac = "",
        sis = "";

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          nomeConto = row[4];
          ts = row[6];
          break;
        case "DATEV":
          nomeConto = row[7];
          daAz = row[9];
          daLp = row[12];
          break;
        case "ZUCCHETTI":
          nomeConto = row[13];
          zuc = row[15];
          break;
        case "SEAC":
          nomeConto = row[16];
          seac = row[18];
          break;
        case "SISTEMI":
          nomeConto = row[19];
          sis = row[21];
          break;
      }

      return [
        denominazione,
        cf,
        abi,
        cab,
        data,
        nomeConto,
        ts,
        daAz,
        daLp,
        zuc,
        seac,
        sis,
      ];
    },
    isAbiOrCabEditable(rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`; // usa direttamente l'indice numerico
      const isEditing = this.editingAbiCab?.[key]; // accesso sicuro con optional chaining

      const row = this.vettoreCodSaldoFinale?.[rowIndex];
      if (!row || !row[2]) return false;

      const [, abi = "", cab = ""] = row[2].split("-");

      return (
        isEditing ||
        (colIndex === 2 && abi === "00000") ||
        (colIndex === 3 && cab === "00000") ||
        (colIndex === 2 && this.isCodContoDefault(cab)) ||
        (colIndex === 3 && this.isCodContoDefault(abi))
      );
    },
    isDateEditable(rowIndex, colIndex) {
      if (colIndex !== 4) return false;

      const key = `${rowIndex}-${colIndex}`;
      if (this.editingDate[key]) return true;

      const mapped = this.mappedSaldoFinale(rowIndex);
      const dateValue = mapped[colIndex];
      return dateValue === "01/01/1970";
    },
    updateMappedCell(rowIndex, colIndex, value) {
      const row = this.vettoreCodSaldoFinale[rowIndex];
      if (!row) return;

      // ABI e CAB sono dentro row[2] (composite cf-abi-cab)
      if (colIndex === 2 || colIndex === 3) {
        const [cf = "", abi = "00000", cab = "00000"] = String(
          row[2] || ""
        ).split("-");
        let newAbi = abi;
        let newCab = cab;

        if (colIndex === 2) newAbi = value || "00000";
        if (colIndex === 3) newCab = value || "00000";

        const newComposite = `${cf}-${newAbi}-${newCab}`;
        this.$set(this.vettoreCodSaldoFinale[rowIndex], 2, newComposite);
        return;
      }

      // Altri campi — aggiorna in base a colonna tabella mappata su array originale:
      switch (colIndex) {
        case 0: // Denominazione (non modificabile o da ignorare, perché è row[1])
          this.$set(this.vettoreCodSaldoFinale[rowIndex], 1, value);
          break;
        case 1: // Codice Fiscale (row[2] contiene cf, non modificabile separatamente, quindi no update)
          // Puoi ignorare o aggiornare solo se vuoi
          break;
        case 4: // Data pagamento
          this.$set(this.vettoreCodSaldoFinale[rowIndex], 3, value);
          break;
        case 5: // Descrizione Cod. Conto
          if (this.output_PC === "TEAMSYSTEM")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 4, value);
          else if (this.output_PC === "DATEV")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 7, value);
          else if (this.output_PC === "ZUCCHETTI")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 13, value);
          else if (this.output_PC === "SEAC")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 16, value);
          else if (this.output_PC === "SISTEMI")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 19, value);
          break;
        case 6: // Cod. conto AVERE TeamSystem
          if (this.output_PC === "TEAMSYSTEM")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 6, value);
          break;
        case 7: // Cod. conto AVERE Datev Aziende
          if (this.output_PC === "DATEV")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 9, value);
          break;
        case 8: // Cod. conto AVERE Datev Liberi Prof.
          if (this.output_PC === "DATEV")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 12, value);
          break;
        case 9: // Cod. conto AVERE Zucchetti
          if (this.output_PC === "ZUCCHETTI")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 15, value);
          break;
        case 10: // Cod. conto AVERE SEAC
          if (this.output_PC === "SEAC")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 18, value);
          break;
        case 11: // Cod. conto AVERE SISTEMI
          if (this.output_PC === "SISTEMI")
            this.$set(this.vettoreCodSaldoFinale[rowIndex], 21, value);
          break;
      }
    },

    isEditableSaldoFinale(colIndex) {
      if (this.output_PC === "TEAMSYSTEM") {
        return colIndex === 6; // Solo colonna AVERE TeamSystem
      } else if (this.output_PC === "DATEV") {
        return colIndex === 7 || colIndex === 8; // Aziende + Liberi Prof
      } else if (this.output_PC === "ZUCCHETTI") {
        return colIndex === 9; // Solo AVERE Zucchetti
      } else if (this.output_PC === "SEAC") {
        return colIndex === 10; // Solo AVERE SEAC
      } else if (this.output_PC === "SISTEMI") {
        return colIndex === 11; // Solo AVERE SISTEMI
      }
      return false;
    },
    validateInputSaldoFinale(rowIndex, colIndex, event) {
      let rawValue = event.target.value;
      let value = rawValue.toString().replace(/[^0-9]/g, ""); // solo numeri

      // ABI e CAB (colIndex 2 e 3) max 5 cifre
      if (colIndex === 2 || colIndex === 3) {
        value = value.slice(0, 5);
      }
      // TEAMSYSTEM colonna 6 con formattazione tipo "12/34/567"
      else if (this.output_PC === "TEAMSYSTEM" && colIndex === 6) {
        if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2);
        if (value.length > 5) value = value.slice(0, 5) + "/" + value.slice(5);
        value = value.slice(0, 9);

        const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
        if (value.length === 9 && !teamSystemRegex.test(value)) {
          value = "";
        }
      }
      // SEAC colonna 10 con limite a 6 cifre
      else if (this.output_PC === "SEAC" && colIndex === 10) {
        value = value.replace(/[^0-9]/g, ""); // Solo numeri
        value = value.slice(0, 6); // Limita a 6 cifre
      }
      // SISTEMI colonna 11 con formattazione "XX.XX.XX" o "XX.XX.XX.XXX", limite 9 cifre numeriche
      else if (this.output_PC === "SISTEMI" && colIndex === 11) {
        value = value.replace(/[^0-9]/g, ""); // Solo numeri
        // Limita a 9 cifre numeriche prima della formattazione
        value = value.slice(0, 9);
        if (value.length > 2 && value[2] !== ".") {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
        if (value.length > 5 && value[5] !== ".") {
          value = value.slice(0, 5) + "." + value.slice(5);
        }
        if (value.length > 8 && value[8] !== ".") {
          value = value.slice(0, 8) + "." + value.slice(8);
        }
        // Non serve slice(0, 9) qui, il limite è già sulle cifre numeriche
      }

      // Aggiorna v-model
      this.$set(this.inputValues, `${rowIndex}-${colIndex}`, value);

      // Aggiorna direttamente SOLO se NON è ABI o CAB
      this.updateMappedCell(rowIndex, colIndex, value);
      if (colIndex === 4) {
        value = rawValue.replace(/[^0-9/]/g, "");

        value = value.replace(/\/+/g, "/");
        // Primo taglio: massimo 10 caratteri (dd/mm/yyyy)
        if (value.length > 10) value = value.slice(0, 10);

        // Formattazione progressiva:
        // 1) Inserisci "/" dopo 2 cifre (giorno)
        if (value.length > 2 && value[2] !== "/") {
          value = value.slice(0, 2) + "/" + value.slice(2);
        }
        // 2) Inserisci "/" dopo 5 caratteri (giorno + mese)
        if (value.length > 5 && value[5] !== "/") {
          value = value.slice(0, 5) + "/" + value.slice(5);
        }

        const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
        if (value.length === 10 && !dateRegex.test(value)) {
          value = "";
        }
        this.$set(this.inputValues, `${rowIndex}-${colIndex}`, value);
        this.updateMappedCell(rowIndex, colIndex, value);
        return;
      }
    },
    blockLetters(event, rowIndex, colKey, colIndex, vettore) {
      const headerName = this.filteredHeaders[colIndex]; // o filteredHeaders
      if (!headerName || !/Cod\. Conto/i.test(headerName)) {
        return; // ← NON fare nulla → permetti tutto
      }
      const currentValue = vettore[rowIndex][colKey] || "";
      const hasNumbers = /\d/.test(currentValue);
      // === Gestione speciale per Backspace/Delete su "N.A." ===
      if (
        currentValue === "N.A." &&
        (event.key === "Backspace" || event.key === "Delete")
      ) {
        event.preventDefault(); // Blocca il comportamento di default
        this.$set(vettore[rowIndex], colKey, ""); // Svuota la cella
        return; // Esci subito
      }
      if (hasNumbers) {
        const key = event.key;
        const allowed = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];

        if (event.ctrlKey || event.metaKey) return;

        if (!allowed.includes(key) && !/[0-9]/.test(key)) {
          event.preventDefault();
        }
      }
    },

    blockPaste(event, colIndex) {
      const headerName = this.filteredHeaders[colIndex];
      if (!headerName || !/Cod\. Conto/i.test(headerName)) {
        return; // ← incolla tutto
      }
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pasted.replace(/\D/g, "");
      const textToInsert = headerName.includes("Datev")
        ? numbersOnly.slice(0, 11)
        : numbersOnly;
      document.execCommand("insertText", false, textToInsert);
    },
    isPCTModified() {
      if (!this.originalPCT) return false;
      if (this.vettoreCodTributoPCT.length !== this.originalPCT.length)
        return true;

      for (let i = 0; i < this.vettoreCodTributoPCT.length; i++) {
        for (let j = 0; j < this.vettoreCodTributoPCT[i].length; j++) {
          if (this.vettoreCodTributoPCT[i][j] !== this.originalPCT[i][j]) {
            return true;
          }
        }
      }
      return false;
    },
    is9001PCTModified() {
      if (!this.original9001PCT) return false;
      if (this.vettoreCodTributo9001_PCT.length !== this.original9001PCT.length)
        return true;

      for (let i = 0; i < this.vettoreCodTributo9001_PCT.length; i++) {
        for (let j = 0; j < this.vettoreCodTributo9001_PCT[i].length; j++) {
          if (
            this.vettoreCodTributo9001_PCT[i][j] !== this.original9001PCT[i][j]
          ) {
            return true;
          }
        }
      }
      return false;
    },
    validateInput(rowIndex, col, vettore) {
      const realColIndex = this.validColumns[col];
      const columnName = this.headers[realColIndex];
      if (!columnName) return;

      let value = vettore[rowIndex][realColIndex] || "";

      // === 1️⃣ Colonne Descrizione Cod. Conto: accettano tutto ===
      const isNomeConto = [
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Datev Aziende",
        "Descrizione Cod. Conto - Datev Lib. Prof.",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
      ].includes(columnName);
      if (isNomeConto) return;

      // === 2️⃣ Gestione robusta di "N.A." ===
      const onlyLetters = value.replace(/[^a-zA-Z]/g, "").toLowerCase();
      if (onlyLetters === "na") {
        const onlyNumbers = value.replace(/\D/g, "");
        if (onlyNumbers.length > 0) {
          value = onlyNumbers;
        } else {
          vettore[rowIndex][realColIndex] = "N.A.";
          return;
        }
      }
      const startsWithLetter = /^[A-Za-z]/.test(value);
      const startsWithDigit = /^\d/.test(value);

      // Se contiene lettere in un campo numerico → forza a "N.A."
      if (/[a-zA-Z]/.test(value)) {
        vettore[rowIndex][realColIndex] = "N.A.";
        return;
      }

      // Descrizione Codice Conto: accetta qualsiasi carattere senza limitazioni
      if (isNomeConto) {
        // Nessuna limitazione applicata
      }
      // TEAM SYSTEM - Codici Dare/Avere
      else if (
        columnName === "Cod. Conto DARE - TeamSystem" ||
        columnName === "Cod. Conto AVERE - TeamSystem"
      ) {
        if (startsWithDigit) {
          const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 2)
            value = value.slice(0, 2) + "/" + value.slice(2);
          if (value.length > 5)
            value = value.slice(0, 5) + "/" + value.slice(5);
          value = value.slice(0, 9);
          if (value.length === 9 && !teamSystemRegex.test(value)) {
            value = "";
          }
        } else if (startsWithLetter) {
          value = value.replace(/[^A-Za-z.]/g, "");
        } else {
          value = "";
        }
      }
      // Cod. Conto Sistemi
      else if (
        columnName === "Cod. Conto DARE - Sistemi" ||
        columnName === "Cod. Conto AVERE - Sistemi"
      ) {
        if (startsWithDigit) {
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 2 && value[2] !== ".") {
            value = value.slice(0, 2) + "." + value.slice(2);
          }
          if (value.length > 5 && value[5] !== ".") {
            value = value.slice(0, 5) + "." + value.slice(5);
          }
          if (value.length > 8 && value[8] !== ".") {
            value = value.slice(0, 8) + "." + value.slice(8);
          }
          value = value.slice(0, 12);
        } else {
          value = "";
        }
      }
      // Cod. conto SEAC
      else if (
        columnName === "Cod. Conto DARE - SEAC" ||
        columnName === "Cod. Conto AVERE - SEAC"
      ) {
        if (startsWithDigit) {
          value = value.replace(/[^0-9]/g, "");
          value = value.slice(0, 6); // Limita a massimo 6 cifre numeriche
        } else {
          value = "";
        }
      }
      // DATEV / ZUCCHETTI - Codici Dare/Avere
      else if (
        columnName.includes("Datev") ||
        columnName.includes("Zucchetti")
      ) {
        if (startsWithDigit) {
          value = value.replace(/\D/g, "");
          if (columnName.includes("Datev")) value = value.slice(0, 11);
        } else if (startsWithLetter) {
          value = value.replace(/[^A-Za-z.]/g, "");
        } else {
          value = "";
        }
      }

      // Salva il valore processato
      vettore[rowIndex][realColIndex] = value;
    },
    fillEmptyWithNA() {
      console.log("RIEMPIMENTO N.A. IN CORSO...");

      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];
            if (!value || String(value).trim() === "") {
              if (
                !col.includes("Descrizione Cod. Conto") &&
                !col.includes("Descrizione")
              ) {
                this.$set(row, colIndex, "N.A.");
              }
            }
          });
        });
      };

      fill(this.vettoreCodTributo, this.getValidColumns());
      if (this.vettoreCodTributoPCT && this.vettoreCodTributoPCT.length > 0) {
        fill(this.vettoreCodTributoPCT, this.validColumnsPCT); // CORRETTO
      }
      // ===== CASO SPECIFICO 9001 (AD HOC, SEPARATO) =====
      // if (this.vettoreCodTributo9001?.length) {
      //   this.vettoreCodTributo9001.forEach((row, rowIndex) => {
      //     // colonne editabili della tabella 9001
      //     [7, 8].forEach((colIndex) => {
      //       const value = this.mapped9001(rowIndex)[colIndex];

      //       if (!value || String(value).trim() === "") {
      //         this.updateMapped9001(rowIndex, colIndex, "N.A.");
      //         this.$set(
      //           this.inputValues9001,
      //           `${rowIndex}-${colIndex}`,
      //           "N.A."
      //         );
      //       }
      //     });
      //   });
      // }

      this.showErrorModal = false;
    },
    fillEmptyWithNoCorr() {
      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];

            // CORRETTO: Usa includes("Descrizione Codice Conto")
            if (
              col.includes("Descrizione Cod. Conto") &&
              (!value || String(value).trim() === "")
            ) {
              this.$set(row, colIndex, "NESSUNA CORRELAZIONE");
            }
          });
        });
      };

      fill(this.vettoreCodTributo, this.getValidColumns());
      if (this.vettoreCodTributoPCT && this.vettoreCodTributoPCT.length > 0) {
        fill(this.vettoreCodTributoPCT, this.validColumnsPCT);
      }
      // if (this.vettoreCodTributo9001?.length) {
      //   this.vettoreCodTributo9001.forEach((row, rowIndex) => {
      //     const colIndex = 6; // Descrizione Cod. Conto
      //     const value = this.mapped9001(rowIndex)[colIndex];

      //     if (!value || String(value).trim() === "") {
      //       this.updateMapped9001(rowIndex, colIndex, "NESSUNA CORRELAZIONE");
      //       this.$set(
      //         this.inputValues9001,
      //         `${rowIndex}-${colIndex}`,
      //         "NESSUNA CORRELAZIONE"
      //       );
      //     }
      //   });
      // }
      this.showErrorModal = false;
    },

    proceedWithWarnings() {
      this.naConfirmed = true;
      this.noCorrConfirmed = true;
      this.showErrorModal = false;
      this.fase_3();
    },
    validateAllInputs() {
      console.log("Vettore 9001 riga 1:", this.vettoreCodTributo9001[0]);
      const validColumns = this.getValidColumns();
      // Per i tributi (possono essere riempiti con N.A.)
      let emptyCells = {
        "Codici Conto mancanti": [],
        "Descrizioni Codici Conto mancanti": [],
      };
      const errorGroupTitles = {
        emptyAbi: "Codice ABI mancante nelle Coordinate bancarie",
        invalidAbi: "Codice ABI non valido nelle Coordinate bancarie",
        emptyCab: "Codice CAB mancante nelle Coordinate bancarie",
        invalidCab: "Codice CAB non valido nelle Coordinate bancarie",
        emptyDataPagamento: "Data pagamento mancante nelle Coordinate bancarie",
        invalidDataPagamento:
          "Data pagamento non valida nelle Coordinate bancarie",
      };
      // Per il Saldo Finale (sempre obbligatori → mai N.A.)
      let emptyCellsSaldoFinale = {
        "Codici Conto mancanti": [],
        "Descrizioni Codici Conto mancanti": [],
      };
      let emptyCells9001 = {
        "Codici Conto mancanti": [],
        "Descrizioni Codici Conto mancanti": [],
      };
      let formatErrors = {
        tributi: [],
        tributi9001: [],
        saldoFinale: [],
      };
      let emptyAbi = [];
      let invalidAbi = [];
      let emptyCab = [];
      let invalidCab = [];
      let emptyDataPagamento = [];
      let invalidDataPagamento = [];
      let naCells = [];
      let noCorrCells = [];

      // === REGEX ===
      const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
      const numberRegex = /^\d+$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      const sistemaContabile = this.output_PC;
      let colonneDaControllare = [];

      const getCodiceContoError = (cellValue) => {
        if (sistemaContabile === "TEAMSYSTEM") {
          return teamSystemRegex.test(cellValue)
            ? null
            : "formato errato, atteso XX/XX/XXX";
        }

        if (sistemaContabile === "DATEV") {
          return cellValue.length >= 5 && cellValue.length <= 11
            ? null
            : "deve contenere da 5 a 11 cifre numeriche";
        }

        if (sistemaContabile === "ZUCCHETTI") {
          return cellValue.length >= 5
            ? null
            : "deve contenere almeno 5 cifre numeriche";
        }

        if (sistemaContabile === "SEAC") {
          const cleaned = cellValue.replace(/[^0-9]/g, "");
          return numberRegex.test(cleaned) && cleaned.length === 6
            ? null
            : "deve contenere esattamente 6 cifre";
        }

        if (sistemaContabile === "SISTEMI") {
          return sistemiRegex.test(cellValue)
            ? null
            : "formato errato, atteso XX.XX.XX o XX.XX.XX.XXX";
        }

        return null;
      };

      // === COLONNE DA CONTROLLARE ===
      if (sistemaContabile === "TEAMSYSTEM") {
        colonneDaControllare = [
          "Cod. Conto DARE - TeamSystem",
          "Cod. Conto AVERE - TeamSystem",
        ];
      } else if (sistemaContabile === "DATEV") {
        colonneDaControllare = [
          "Cod. Conto DARE - Datev Aziende",
          "Cod. Conto AVERE - Datev Aziende",
          "Cod. Conto DARE - Datev Lib. Prof.",
          "Cod. Conto AVERE - Datev Lib. Prof.",
        ];
      } else if (sistemaContabile === "ZUCCHETTI") {
        colonneDaControllare = [
          "Cod. Conto DARE - Zucchetti",
          "Cod. Conto AVERE - Zucchetti",
        ];
      } else if (sistemaContabile === "SEAC") {
        colonneDaControllare = [
          "Cod. Conto DARE - SEAC",
          "Cod. Conto AVERE - SEAC",
        ];
      } else if (sistemaContabile === "SISTEMI") {
        colonneDaControllare = [
          "Cod. Conto DARE - Sistemi",
          "Cod. Conto AVERE - Sistemi",
        ];
      }

      // === FUNZIONE DI VALIDAZIONE TRIBUTI ===
      const validateTributi = (vector, headers, validCols, prefix = "") => {
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            let cellValue = vector[rowIndex][colIndex];
            if (cellValue) cellValue = String(cellValue).trim();

            // SALTA N.A. e NESSUNA CORRELAZIONE nel controllo celle vuote
            if (cellValue === "N.A." || cellValue === "NESSUNA CORRELAZIONE") {
              continue;
            }

            // CELLE VUOTE
            if (!cellValue) {
              if (col.includes("Descrizione Cod. Conto")) {
                emptyCells["Descrizioni Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else {
                emptyCells["Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              }
              continue;
            }

            // FORMATO (solo colonne contabili)
            if (colonneDaControllare.includes(col)) {
              const errorMsg = getCodiceContoError(cellValue);

              if (errorMsg) {
                formatErrors.tributi.push(
                  `${prefix}Riga ${rowIndex + 1}, "${col}": ${errorMsg}`
                );
              }
            }
          }
        }

        // RILEVA N.A. e NESSUNA CORRELAZIONE
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            const cellValue = vector[rowIndex][colIndex];
            const cellStr = String(cellValue).trim().toUpperCase();

            if (
              !col.includes("Descrizione") &&
              !col.includes("Descrizione Cod. Conto") &&
              cellStr === "N.A."
            ) {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }
            if (
              col.includes("Descrizione Cod. Conto") &&
              cellStr === "NESSUNA CORRELAZIONE"
            ) {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // === VALIDAZIONE VETTORI ===
      validateTributi(
        this.vettoreCodTributo,
        this.filteredHeaders,
        validColumns
      );
      if (this.vettoreCodTributoPCT && this.vettoreCodTributoPCT.length > 0) {
        validateTributi(
          this.vettoreCodTributoPCT,
          this.filteredHeadersPCT,
          this.validColumnsPCT,
          "[SALVATI] "
        );
      }
      const validate9001 = (vector, prefix = "") => {
        if (!Array.isArray(vector) || vector.length === 0) return;

        const headersVisibili = this.headers9001;
        const validCols = this.validColumns9001;

        // Mappa: indice visualizzato → indice reale nel vettore da validare
        const uiToRealIndex = {
          6: 4, // Descrizione Cod. Conto     → vettore[4]
          7: 5, // Cod. Conto DARE            → vettore[5]
          8: 6, // Cod. Conto AVERE           → vettore[6]
        };

        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (const uiCol of [6, 7, 8]) {
            if (!validCols.includes(uiCol)) continue;

            const realCol = uiToRealIndex[uiCol];
            const visibleHeader = headersVisibili[uiCol];

            let rawValue = vector[rowIndex][realCol];
            let cellValue =
              rawValue === null || rawValue === undefined
                ? ""
                : String(rawValue).trim();

            // Log per debug (tienilo per ora)
            console.log(
              `9001 r${
                rowIndex + 1
              } UI-col${uiCol} (real ${realCol}) | raw=«${JSON.stringify(
                rawValue
              )}» | cleaned=«${cellValue}» | len=${cellValue.length}`
            );

            // 1. Salta se N.A. o NESSUNA CORRELAZIONE
            if (cellValue === "N.A." || cellValue === "NESSUNA CORRELAZIONE") {
              continue;
            }

            // 2. CELLA VUOTA → errore mancante
            if (cellValue === "") {
              if (uiCol === 6) {
                emptyCells9001["Descrizioni Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else if (uiCol === 7 || uiCol === 8) {
                emptyCells9001["Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              }
              continue;
            }

            // 3. CONTROLLO FORMATO solo per codici conto (UI col 7 e 8)
            if (uiCol === 7 || uiCol === 8) {
              const errorMsg = getCodiceContoError(cellValue);

              if (errorMsg) {
                formatErrors.tributi9001.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  } - ${visibleHeader}: ${errorMsg}`
                );
              }
            }
          }
        }

        // === RILEVAZIONE N.A. e NESSUNA CORRELAZIONE ===
        // Applica la stessa mappa anche qui!
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (const uiCol of [6, 7, 8]) {
            if (!validCols.includes(uiCol)) continue;

            const realCol = uiToRealIndex[uiCol];
            let rawValue = vector[rowIndex][realCol];
            let cellValue =
              rawValue === null || rawValue === undefined
                ? ""
                : String(rawValue).trim().toUpperCase();

            const visibleHeader = headersVisibili[uiCol];

            if ((uiCol === 7 || uiCol === 8) && cellValue === "N.A.") {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }
            if (uiCol === 6 && cellValue === "NESSUNA CORRELAZIONE") {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // === VALIDAZIONE SPECIFICA PER TABELLE 9001 ===
      validate9001(this.vettoreCodTributo9001);
      validate9001(this.vettoreCodTributo9001_PCT, "[SALVATI] ");
      formatErrors.saldoFinale.push(
        ...bankGroupErrors(
          this.vettoreCodSaldoFinale,
          this.output_PC,
          this.vettoreClienti,
          this.codContoDefault
        )
      );
      // === REPORTING ERRORI BLOCCANTI ===
      const detectedErrors = [];
      const codiciTributoSection = "CODICI TRIBUTO INDIVIDUATI";
      const codiciTributo9001Section = "CODICI TRIBUTO 9001";
      const coordinateBancarieSection = "COORDINATE BANCARIE";

      const coordinateErrorGroups = {
        emptyAbi,
        invalidAbi,
        emptyCab,
        invalidCab,
        emptyDataPagamento,
        invalidDataPagamento,
      };

      Object.entries(coordinateErrorGroups).forEach(([key, arr]) => {
        if (arr.length > 0) {
          detectedErrors.push({
            section: coordinateBancarieSection,
            type: key.replace(/([A-Z])/g, "-$1").toLowerCase(),
            title: errorGroupTitles[key] + ":", // ← qui usi il titolo carino
            messages: arr,
          });
        }
      });

      if (emptyCells["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciTributoSection,
          type: "empty-cells",
          title: "Codici Conto mancanti:",
          messages: emptyCells["Codici Conto mancanti"],
        });
      }
      if (emptyCells["Descrizioni Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciTributoSection,
          type: "empty-cells",
          title: "Descrizioni Codici Conto mancanti:",
          messages: emptyCells["Descrizioni Codici Conto mancanti"],
        });
      }
      // Saldo Finale → SEMPRE bloccante, MAI pulsante N.A.
      if (emptyCellsSaldoFinale["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: coordinateBancarieSection,
          type: "empty-cells-obbligatorie", // ← tipo diverso → NON attiva il pulsante
          title: "Codici Conto mancanti nelle Coordinate bancarie:",
          messages: emptyCellsSaldoFinale["Codici Conto mancanti"],
        });
      }
      if (
        emptyCellsSaldoFinale["Descrizioni Codici Conto mancanti"].length > 0
      ) {
        detectedErrors.push({
          section: coordinateBancarieSection,
          type: "empty-cells-obbligatorie",
          title: "Descrizioni Codici Conto mancanti nelle Coordinate bancarie:",
          messages: emptyCellsSaldoFinale["Descrizioni Codici Conto mancanti"],
        });
      }
      if (emptyCells9001["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciTributo9001Section,
          type: "empty-cells-obbligatorie",
          title: "Codici Conto mancanti nei Codici Tributo 9001:",
          messages: emptyCells9001["Codici Conto mancanti"],
        });
      }
      if (emptyCells9001["Descrizioni Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciTributo9001Section,
          type: "empty-cells-obbligatorie",
          title: "Descrizioni Codici Conto mancanti nei Codici Tributo 9001:",
          messages: emptyCells9001["Descrizioni Codici Conto mancanti"],
        });
      }
      if (formatErrors.tributi.length > 0) {
        detectedErrors.push({
          section: codiciTributoSection,
          type: "format-errors",
          title: "Codici Conto non validi:",
          messages: formatErrors.tributi,
        });
      }
      if (formatErrors.tributi9001.length > 0) {
        detectedErrors.push({
          section: codiciTributo9001Section,
          type: "format-errors",
          title: "Codici Conto non validi nei Codici Tributo 9001:",
          messages: formatErrors.tributi9001,
        });
      }
      if (formatErrors.saldoFinale.length > 0) {
        detectedErrors.push({
          section: coordinateBancarieSection,
          type: "format-errors",
          title: "Codici Conto non validi nelle Coordinate bancarie:",
          messages: formatErrors.saldoFinale,
        });
      }

      const errorSectionOrder = {
        [codiciTributoSection]: 0,
        [codiciTributo9001Section]: 1,
        [coordinateBancarieSection]: 2,
      };
      detectedErrors.sort(
        (a, b) =>
          (errorSectionOrder[a.section] ?? 99) -
          (errorSectionOrder[b.section] ?? 99)
      );

      // === AVVISO UNIFICATO N.A. + NESSUNA CORRELAZIONE ===
      if (detectedErrors.length === 0) {
        const hasNA = !this.naConfirmed && naCells.length > 0;
        const hasNoCorr = !this.noCorrConfirmed && noCorrCells.length > 0;

        if (hasNA || hasNoCorr) {
          // HELPER UNIFICATI
          const plural = (c, s, p) => (c === 1 ? s : p);
          const foundM = (c) => (c === 1 ? "Trovato" : "Trovati"); // Maschile (per codici o misti)
          const foundF = (c) => (c === 1 ? "Trovata" : "Trovate"); // Femminile (per descrizioni)
          const assignedM = (c) => (c === 1 ? "assegnato" : "assegnati"); // Maschile
          const thisTheseM = (c) => (c === 1 ? "questo" : "questi"); // Maschile
          const thisTheseF = (c) => (c === 1 ? "questa" : "queste"); // Femminile
          const theTheM = (c) => (c === 1 ? "Il" : "I"); // Maschile
          const theTheF = (c) => (c === 1 ? "La" : "Le"); // Femminile
          const willBe = (c) => (c === 1 ? "verrà" : "verranno"); // Neutro
          const valuedM = (c) => (c === 1 ? "valorizzato" : "valorizzati"); // Maschile (per codici)
          const keptF = (c) => (c === 1 ? "mantenuta" : "mantenute"); // Femminile (per descrizioni)

          let title = "",
            messages = [],
            question = "";

          if (hasNA && hasNoCorr) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundM(naCells.length + noCorrCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' e ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = [...naCells, ...noCorrCells];
            question = `Vuoi proseguire? ${theTheM(
              naCells.length
            )} ${cod} ${willBe(naCells.length)} ${valuedM(
              naCells.length
            )} con 'N.A.' e ${theTheF(
              noCorrCells.length
            ).toLowerCase()} ${nom} ${willBe(noCorrCells.length)} ${keptF(
              noCorrCells.length
            )} come 'NESSUNA CORRELAZIONE'.`;
          } else if (hasNA) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            title = `${foundM(naCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' (non ${assignedM(naCells.length)}):`;
            messages = naCells;
            question = `Vuoi proseguire senza assegnare ${thisTheseM(
              naCells.length
            )} ${cod}?<br>${
              willBe(naCells.length).charAt(0).toUpperCase() +
              willBe(naCells.length).slice(1)
            } ${valuedM(naCells.length)} con 'N.A.'.`;
          } else if (hasNoCorr) {
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundF(noCorrCells.length)} ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = noCorrCells;
            question = `Vuoi proseguire con ${thisTheseF(
              noCorrCells.length
            )} ${nom} senza correlazione?<br>${
              willBe(noCorrCells.length).charAt(0).toUpperCase() +
              willBe(noCorrCells.length).slice(1)
            } ${keptF(noCorrCells.length)} come 'NESSUNA CORRELAZIONE'.`;
          }

          detectedErrors.push({
            section: "AVVISI",
            type: "combined-warning",
            title,
            messages,
            question,
          });
        }
      }

      if (detectedErrors.length > 0) {
        this.errorsData = detectedErrors;
        this.showErrorModal = true;
        return false;
      }

      return true;
    },
    isRealDate(dateStr) {
      const [day, month, year] = dateStr.split("/").map(Number);
      const dateObj = new Date(year, month - 1, day); // JS usa mesi da 0 a 11
      return (
        dateObj.getFullYear() === year &&
        dateObj.getMonth() === month - 1 &&
        dateObj.getDate() === day &&
        year >= 1970
      );
    },
    getNomeF24(testo) {
      if (!testo) return "";

      const parti = testo.split(" - ").map((p) => p.trim());

      if (parti.length <= 1) {
        return parti[0] || "";
      }

      // Data = ultimo elemento → lo escludiamo dal nome
      let nomeParti = parti.slice(0, -1);

      // Controlla se l'ultima parte del nome (penultima complessiva) sembra un CF
      if (nomeParti.length >= 1) {
        const penultimo = nomeParti[nomeParti.length - 1];
        // Lunghezza tipica CF + check alfanumerico semplice
        if (
          (penultimo.length === 11 || penultimo.length === 16) &&
          /^[A-Z0-9]+$/.test(penultimo)
        ) {
          nomeParti.pop(); // rimuoviamo il CF dal nome visualizzato
        }
      }

      return nomeParti.join(" - ");
    },

    getDataF24(testo) {
      if (!testo) return "";

      const parti = testo.split(" - ").map((p) => p.trim());
      if (parti.length === 0) return "";

      // Sempre l'ultimo pezzo
      return parti[parti.length - 1];
    },
    formattaCFPI(event, cliente) {
      let valore = event.target.value
        .replace(/[^0-9A-Za-z]/g, "")
        .toUpperCase();

      this.$set(cliente, 4, valore);

      // riposizionamento cursore opzionale
      this.$nextTick(() => {
        event.target.value = valore;
        event.target.setSelectionRange(valore.length, valore.length);
      });
    },

    isValidCodiceFiscale(val) {
      if (!val) return true; // vuoto → ok (non obbligatorio)
      return validFiscalCode(val);
    },
    selezionaColonna(tipo) {
      const tuttiSelezionati = this.vettoreClienti.every((c) => c[2] === tipo);

      this.vettoreClienti.forEach((cliente, i) => {
        this.$set(this.vettoreClienti[i], 2, tuttiSelezionati ? 0 : tipo);
      });
    },
    hasNessunaCorrelazione(value) {
      if (typeof value === "string") {
        return value.toLowerCase().includes("nessuna correlazione");
      }
      return false;
    },
    isNessuno(value) {
      return value === "N.A.";
    },
    toggleTableExpansion() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    toggleTableSaldoExpansion() {
      this.isTableSaldoExpanded = !this.isTableSaldoExpanded;
    },
    toggleTableTributoPCTExpansion() {
      this.isTableTributoPCTExpanded = !this.isTableTributoPCTExpanded;
    },
    toggleTable9001Expansion() {
      this.isTable9001Expanded = !this.isTable9001Expanded;
    },
    toggleTable9001PCTExpansion() {
      this.isTable9001PCTExpanded = !this.isTable9001PCTExpanded;
    },
    async handleDownload(event) {
      event.preventDefault();

      if (!this.confermaConversione) {
        this.errorMessage = "Devi confermare il numero di conversioni!";
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/download`,
          null,
          { responseType: "blob" }
        );
        this.hasDownloaded = true;
        this.fetchConversionCount();

        // Crea link per scaricare il blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.fileName);
        document.body.appendChild(link);
        link.click();
        this.hasOutputDownloadStarted = true;
        link.remove();
        window.URL.revokeObjectURL(url);
        await axios.post(`${API_BASE_URL}/log_download`, {
          job_id: this.jobId,
          file_name: this.selectedFile
            ? this.selectedFile.name
            : "file_sconosciuto",
          output_file_name: this.filePath,
          output_display_name: this.fileName,
          file_scaricati: this.filesNames ? this.filesNames : [],
          operazione: "Conversione Modello F24",
        });
        this.removePersistedJobState();
      } catch (error) {
        this.errorMessage =
          error.response?.status === 402
            ? "I crediti disponibili non sono più sufficienti per scaricare il file."
            : "Errore durante il processo di download.";
        console.error("Errore nel handleDownload:", error);
      }
    },

    // Metodo per ottenere il contatore delle conversioni dal backend
    fetchConversionCount() {
      axios
        .get(`${API_BASE_URL}/get_conversion_count`)
        .then((response) => {
          this.creditiDisponibili = response.data.crediti_disponibili;
        })
        .catch((error) => {
          console.error("Errore nel recupero del contatore:", error);
        });
    },
    fetchPrezziConversione() {
      axios
        .get(`${API_BASE_URL}/getPrezziConversione`)
        .then((response) => {
          this.creditiPerF24 = response.data.crediti_per_f24;
        })
        .catch((error) => {
          console.error("Errore nel recupero dei prezzi conversione:", error);
        });
    },
    async fetchF24ExtractorSetting() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/datev_extractor_setting`
        );
        this.f24NewExtractorEnabled = !!response.data.use_f24_new_extractor;
      } catch (error) {
        console.warn(
          "Impossibile leggere lo stato dell'estrattore IA F24:",
          error
        );
        this.f24NewExtractorEnabled = false;
      }
    },
    async fetchUserCausali() {
      try {
        const response = await axios.get(`${API_BASE_URL}/user_causali`);
        this.causaleModelliF24 = response.data?.causale_modelli_f24 || "";
      } catch (error) {
        console.warn("Impossibile leggere la causale Modelli F24:", error);
      }
    },
    normalizeCausale(value) {
      return String(value || "")
        .trim()
        .toUpperCase();
    },
    isValidCausale(value) {
      return /^[A-Z0-9]{1,4}$/.test(this.normalizeCausale(value));
    },
    handleCausaleDraftInput() {
      this.causaleDraft = this.normalizeCausale(this.causaleDraft).slice(0, 4);
      this.causaleError = "";
    },
    needsF24Causale() {
      return (
        this.flag_csv_import &&
        this.output_PC === "DATEV" &&
        !this.normalizeCausale(this.causaleModelliF24)
      );
    },
    openF24CausaleModal({
      retryAfterSave = false,
      retryFase1AfterSave = false,
    } = {}) {
      this.retryFase1AfterCausale = retryFase1AfterSave;
      this.retryFase3AfterCausale = retryAfterSave;
      this.causaleDraft = this.normalizeCausale(this.causaleModelliF24);
      this.causaleError = "";
      this.showCausaleModal = true;
    },
    closeF24CausaleModal() {
      this.showCausaleModal = false;
      this.retryFase1AfterCausale = false;
      this.retryFase3AfterCausale = false;
      this.causaleError = "";
    },
    async saveF24Causale() {
      const causale = this.normalizeCausale(this.causaleDraft);
      if (!this.isValidCausale(causale)) {
        this.causaleError =
          "La causale deve contenere da 1 a 4 caratteri alfanumerici.";
        return;
      }
      this.savingCausale = true;
      try {
        const response = await axios.post(`${API_BASE_URL}/user_causali`, {
          causale_modelli_f24: causale,
        });
        this.causaleModelliF24 = response.data?.causale_modelli_f24 || causale;
        this.showCausaleModal = false;
        const shouldRetryFase1 = this.retryFase1AfterCausale;
        const shouldRetryFase3 = this.retryFase3AfterCausale;
        this.retryFase1AfterCausale = false;
        this.retryFase3AfterCausale = false;
        if (shouldRetryFase1) {
          this.fase_1();
        } else if (shouldRetryFase3) {
          this.fase_3();
        }
      } catch (error) {
        this.causaleError =
          error.response?.data?.error ||
          "Errore durante il salvataggio della causale.";
      } finally {
        this.savingCausale = false;
      }
    },
    startDelayMessageTimer() {
      this.delayTimer = setTimeout(() => {
        this.showDelayedMessage = true;
      }, 10000);
      // Cambia il testo dopo 30 secondi totali
      this.updateTimer = setTimeout(() => {
        this.delayedMessageUpdated = true;
      }, 30000);
    },
    clearDelayMessageTimer() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.updateTimer);
      this.showDelayedMessage = false;
      this.delayedMessageUpdated = false;
    },
    loadSettings() {
      const loaded = getUserSettings();

      // Merge sicuro: sovrascrive i default con i valori reali (se presenti)
      this.settings = {
        ...this.settings, // mantiene i default se qualcosa manca
        ...loaded,
      };

      // Dopo aver caricato le settings, applica le preferenze specifiche
      this.applySoftwarePreference();

      console.log("Tutte le impostazioni caricate:", this.settings);
    },

    // Metodo separato solo per applicare la preferenza software
    // (lo teniamo separato per chiarezza, ma potrebbe anche stare dentro loadAllSettings)
    applySoftwarePreference() {
      const saved = this.settings.software_contabile || "default";

      const mapping = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SISTEMI: "SISTEMI",
        SEAC: "SEAC",
      };

      if (mapping[saved]) {
        this.output_PC = mapping[saved];
      }
    },
    selectFirstAvailableSubPhase() {
      this.currentSubPhase = this.availablePhases[0] || "";
    },
    nextSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex < phases.length - 1) {
        this.currentSubPhase = phases[currentIndex + 1];
      }
    },
    prevSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex > 0) {
        const previousPhase = phases[currentIndex - 1];
        if (previousPhase === "Q") {
          this.conversionDiagnosticsModal.notificationIndex = 0;
          this.conversionDiagnosticsModal.summary =
            this.activeF24DiagnosticNotification(
              this.conversionDiagnosticsModal.rootSummary,
              this.conversionDiagnosticsModal.notificationQueue,
              0
            );
        }
        this.currentSubPhase = previousPhase;
      }
    },
  },
  created() {
    this.userEmail = localStorage.getItem("userEmail");
  },
  async mounted() {
    this.fetchConversionCount();
    this.fetchPrezziConversione();
    this.fetchF24ExtractorSetting();
    this.fetchUserCausali();
    this.loadSettings();
    await this.cleanupPurgeableJobs();
    await this.resumeStoredJob();
    document.addEventListener("click", this.closeF24CodTributoViewDropdown);
    window.addEventListener("focus", this.fetchF24ExtractorSetting);
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.addEventListener("pagehide", this.handleWindowPageHide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeF24CodTributoViewDropdown);
    window.removeEventListener("focus", this.fetchF24ExtractorSetting);
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.removeEventListener("pagehide", this.handleWindowPageHide);
    this.stopJobPolling();
  },
  beforeRouteLeave(to, from, next) {
    if (this.shouldConfirmReset()) {
      this.openConversionInterruptModal("leave", next);
      return;
    }

    const finalize = async () => {
      if (!this.jobId) return;
      if (this.isPollableJobStatus(this.jobStatus)) {
        await this.cancelActiveJob(false);
        return;
      }
      await this.cleanupSpecificJob(this.jobId);
      await this.cleanupPurgeableJobs();
      this.clearJobState();
    };

    finalize().finally(() => next());
  },
};
</script>

<style scoped>
.ai-converter-badge {
  position: absolute;
  top: 14px;
  right: 18px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid rgba(51, 105, 135, 0.24);
  border-radius: 999px;
  background: #edf6fb;
  color: #285a78;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1;
  text-transform: uppercase;
  box-shadow: 0 8px 18px rgba(51, 105, 135, 0.12);
  user-select: none;
}

.ai-converter-badge i {
  font-size: 12px;
  color: #336987;
}

.f24-client-context-note {
  display: flex;
  align-items: center;
  gap: 0.46rem;
  box-sizing: border-box;
  width: calc(100% - 1rem);
  margin: 0 auto;
  padding: 0.34rem 0.68rem;
  border: 1px solid rgba(43, 99, 157, 0.18);
  border-top: 0;
  border-radius: 0;
  background: #f4f8fc;
  color: #526170;
  font-size: 0.76rem;
  font-weight: 650;
  line-height: 1.2;
}

.f24-client-context-note > i {
  color: #2367ad;
  font-size: 0.78rem;
}

.fase2-results-body {
  display: block;
  padding-top: 0;
}

.result-container--quality {
  overflow: hidden;
}

.result-container--quality .fase2 {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}

.result-container--quality .numerofaseAttuale,
.result-container--quality .title-conv {
  flex: 0 0 auto;
}

.result-container--quality .fase2-results-body {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.fase2.f24-bank-phase {
  height: 100%;
}

.f24-bank-phase .fase2-results-body:not(.dashboard-table-expanded) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: calc(100% - 3.5rem);
  max-height: none;
  min-height: 0;
}

.f24-bank-phase .f24-subphase-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.fase2-results-body.dashboard-table-expanded {
  position: absolute;
  inset: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-height: none;
  padding: 1rem;
  background: #fff;
  border-radius: 5px;
}

.f24-table-dashboard {
  flex: 0 0 auto;
}

.f24-9001-code-context {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #47596b;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.f24-9001-code-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #e8eef3;
  color: #2d546c;
  font-size: 0.7rem;
}

.f24-table-dashboard .codconto-dashboard-tools,
.f24-table-dashboard .codconto-dashboard-filters {
  display: inline-flex;
  align-items: center;
}

.f24-table-dashboard .codconto-dashboard-tools {
  order: 2;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
}

.f24-table-dashboard .codconto-dashboard-filters {
  order: 1;
  flex: 1 1 auto;
  justify-content: flex-start;
  margin-right: auto;
}

.codconto-dashboard-icon-button {
  width: 31px;
  padding: 0;
}

.f24-table-dashboard
  .codconto-dashboard-tools
  > .codconto-dashboard-icon-button:first-child {
  order: 99;
}

.f24-table-dashboard
  .codconto-dashboard-tools
  > .codconto-dashboard-button:not(.codconto-dashboard-icon-button):not(
    .codconto-dashboard-save
  ):not(.codconto-dashboard-reset) {
  flex: 0 0 8.6rem;
  width: 8.6rem;
}

.codconto-dashboard-button:hover:not(:disabled),
.codconto-dashboard-button.active {
  border-color: rgba(35, 100, 170, 0.32);
  background: #eef4fb;
  color: #174f86;
}

.codconto-dashboard-button:disabled {
  cursor: not-allowed;
  color: #9aa6b4;
  background: #f4f6f8;
  box-shadow: none;
}

.codconto-dashboard-save:not(:disabled) {
  border-color: rgba(35, 100, 170, 0.34);
  background: #2367ad;
  color: #ffffff;
}

.codconto-dashboard-save:hover:not(:disabled),
.codconto-dashboard-save.active:not(:disabled) {
  border-color: rgba(35, 100, 170, 0.44);
  background: #1f5b9c;
  color: #ffffff;
}

.codconto-dashboard-reset:not(:disabled) {
  background: #ffffff;
  color: #5f6368;
}

.codconto-table-dashboard .codconto-code-view-controls,
.codconto-table-dashboard .pdc-client-view-controls {
  position: relative;
  top: auto;
  right: auto;
  z-index: 20;
}

.codconto-table-dashboard .pdc-client-view-controls {
  width: 160px;
}

.fase2-results-body .cod_conto_table_div,
.fase2-results-body .cod_conto_table_divPCT,
.fase2-results-body .vettore9001-table,
.fase2-results-body .saldo-final-table {
  max-height: clamp(19.15rem, 45dvh, 32rem);
}

.fase2-results-body .saldo-final-table {
  margin-top: 0;
}

.fase2-results-body.pdc-client-table-mode .cod_conto_table_div,
.fase2-results-body.pdc-client-table-mode .cod_conto_table_divPCT {
  max-height: clamp(18.35rem, 43dvh, 31rem);
}

.dashboard-table-expanded .title-conv {
  display: none;
}

.dashboard-table-expanded .codconto-table-dashboard {
  position: sticky;
  top: 0;
  width: 100%;
  margin: 0;
}

.dashboard-table-expanded .f24-client-context-note {
  width: 100%;
}

.dashboard-table-expanded .f24-subphase-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard-table-expanded
  .f24-subphase-content
  > div:not(.edit-session-actions):not(.table-hidden),
.dashboard-table-expanded .divPCTtable:not(.table-hidden) {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  max-height: none;
  overflow: hidden;
}

.dashboard-table-expanded .divPCTtable.table-hidden {
  display: none;
}

.dashboard-table-expanded .cod_conto_table_div,
.dashboard-table-expanded .cod_conto_table_div.expanded,
.dashboard-table-expanded .cod_conto_table_divPCT,
.dashboard-table-expanded .cod_conto_table_divPCT.expanded,
.dashboard-table-expanded .vettore9001-table,
.dashboard-table-expanded .vettore9001-table.expanded,
.dashboard-table-expanded .saldo-final-table,
.dashboard-table-expanded .saldo-final-table.expanded {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  width: 100%;
  height: auto;
  max-height: none;
  min-height: 0;
  margin-top: 0;
  z-index: 1;
  flex: 1 1 auto;
  overflow: auto;
}

.fase2-results-body.dashboard-table-expanded.pdc-client-table-mode
  .cod_conto_table_div,
.fase2-results-body.dashboard-table-expanded.pdc-client-table-mode
  .cod_conto_table_divPCT {
  max-height: none;
  height: auto;
}

.fase2-results-body.dashboard-table-expanded .subphase-navigation {
  display: none;
}

.pdc-client-view-controls {
  display: block;
  position: absolute;
  top: 48px;
  right: 25px;
  width: 160px;
  z-index: 8;
  color: #173142;
}

.pdc-client-view-trigger {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  width: 100%;
  min-width: 0;
  height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(72, 84, 116, 0.24);
  border-radius: 8px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.7rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}

.pdc-client-view-trigger span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pdc-client-view-trigger i {
  flex: 0 0 auto;
}

.pdc-client-view-trigger i:last-child {
  margin-left: auto;
}

.pdc-client-view-trigger:hover:not(:disabled) {
  border-color: rgba(72, 84, 116, 0.42);
  background: #f4f5f8;
}

.pdc-client-view-trigger:disabled {
  cursor: not-allowed;
  color: #8a98a8;
  background: #f7f8fa;
  box-shadow: none;
}

.pdc-client-view-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 220px;
  max-height: 250px;
  overflow: auto;
  padding: 6px;
  border: 1px solid rgba(72, 84, 116, 0.18);
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(8, 40, 64, 0.18);
}

.pdc-client-view-menu button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 34px;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #082840;
  font-size: 0.86rem;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
}

.pdc-client-view-menu button:hover,
.pdc-client-view-menu button.active {
  background: #eef4fb;
  color: #174f86;
}

.pdc-client-view-menu-title {
  padding: 7px 10px 3px;
  color: #607178;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
}

.f24-client-custom-cell {
  position: relative;
  z-index: 0;
  background: rgba(217, 119, 6, 0.09) !important;
}

.f24-client-custom-cell:focus-within {
  background: transparent !important;
  box-shadow: none;
}

.f24-client-custom-cell:focus-within .f24-client-custom-marker {
  display: none;
}

.f24-client-custom-cell .editable-input {
  box-sizing: border-box;
  width: 96%;
  margin: 0 auto;
  padding-right: 1.45rem;
}

.f24-client-custom-cell > .cell-display-state {
  display: inline-flex;
  box-sizing: border-box;
  max-width: calc(100% - 1.45rem);
  padding-right: 0.35rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.f24-client-custom-marker {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
  cursor: help;
  transform: translateY(-50%);
}

.f24-client-custom-marker i {
  font-size: 0.75rem;
  line-height: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.contenitore-f24 .action-button {
  background-color: #336987;
}
.contenitore,
.headerButtonsf24 {
  background-color: rgb(243 243 243 / 99%);
  /* #48709b */
  border: 2px solid rgba(223, 223, 223, 0.82) !important;
}
.headerButtonsf24 .tool-button i,
.headerButtonsf24 i {
  color: #274f66 !important;
}
.headerButtonsf24 .tool-button i:hover,
.headerButtonsf24 i:hover {
  color: rgb(91, 94, 91) !important;
}
.italic-text {
  font-style: italic;
  font-size: 0.75rem !important;
  color: rgb(156, 156, 156);
}
.titleConvF24 {
  color: #274f66;
  width: 20rem;
  border-bottom: 1px solid #b2b2b2;
  padding-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.client-table thead {
  height: 55px; /* Se desideri forzare una altezza specifica */
}
.client-table td {
  font-size: 0.8rem;
}
/* .cod_conto_table_div--with-max-height {
  max-height: 11.5rem;
}
.cod_conto_table_div--with-max-height2 {
  max-height: 13.5rem;
} */
.saldo-final-table.expanded {
  position: absolute;
  margin-top: 0rem !important;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 100%;
  height: 100%;
  background: #fff; /* Sfondo se vuoi differenziarlo */
  z-index: 999; /* Porta in primo piano la tabella */
  overflow: auto;
  border-radius: 5px;
}
.expand-buttontributo {
  z-index: 10;
  margin-bottom: 1rem;
  font-size: 21px; /* Dimensione dell'icona */
  position: absolute;
  top: 7px;
  left: 8px;
  color: #aaa9a9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}
.expand-buttontributo:hover {
  transform: scale(1.1); /* Ingrandisce leggermente al passaggio del mouse */
  color: rgb(136, 135, 135); /* Colore diverso al hover */
}
.expand-buttonSaldo {
  z-index: 10;
  margin-bottom: 1rem;
  font-size: 21px; /* Dimensione dell'icona */
  position: absolute;
  top: 7px;
  left: 8px;
  color: #aaa9a9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}
.expand-buttonSaldo:hover {
  transform: scale(1.1); /* Ingrandisce leggermente al passaggio del mouse */
  color: rgb(136, 135, 135); /* Colore diverso al hover */
}
.saldo-final-table {
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 21rem;
  margin-top: 1.5rem;
  font-size: 0.85rem !important;
}

.saldo-final-table thead {
  font-size: 0.85rem;
  position: sticky;
  top: 0; /* Posiziona la riga in cima durante lo scorrimento */
  z-index: 1;
  box-sizing: border-box; /* Include il bordo nell'altezza */
}

.codcontotablePCT-datev thead,
.codcontotablePCT thead,
.codtributotable-datev thead,
.codtributotable thead {
  position: sticky;
  top: 0;
  z-index: 30;
  background: #eef2f4;
}

.codcontotablePCT-datev thead th,
.codcontotablePCT thead th,
.codtributotable-datev thead th,
.codtributotable thead th {
  position: relative;
  z-index: 31;
  background: #eef2f4;
}

.codcontotablePCT-datev thead th,
.codcontotablePCT thead th,
.codtributotable-datev thead th,
.codtributotable thead th,
.saldo-final-table thead th,
.saldo-final-table thead td {
  padding: 8px 5px; /* molto più compatto */
  line-height: 1;
  height: 1.9rem; /* imposta un'altezza ridotta */
  justify-content: center !important;
  text-align: center;
}
.codtributotable td:nth-child(3) {
  text-align: left;
}
.cod-conto-individuati {
  font-size: 1.1em;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  min-height: 10rem;
  background: white;
  border-radius: 12px;
  width: calc(100vw - 2rem);
  max-width: 66rem;
  min-width: 0;
  padding: 1rem;
  box-sizing: border-box;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: modalFadeIn 0.3s ease;
  max-height: calc(100vh - 2rem);
  overflow: auto;
}

.modal-content :deep(.store-card),
.modal-content :deep(.skeleton-loader) {
  margin: 0 auto;
}

.causale-modal-content {
  position: relative;
  width: min(28rem, calc(100vw - 2rem));
  background: #fff;
  border-radius: 8px;
  padding: 1.6rem 1.4rem 1.4rem;
  box-shadow: 0 18px 45px rgba(15, 42, 62, 0.22);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.causale-modal-close {
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #607178;
  font-size: 1.05rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.causale-modal-close:hover {
  background: #f1f4f6;
  color: #102a3e;
}

.causale-modal-content h3 {
  margin: 0;
  color: #102a3e;
  font-size: 1.35rem;
}

.causale-modal-content p {
  margin: 0;
  color: #4d5f6d;
  font-size: 0.98rem;
  line-height: 1.45;
}

.causale-input {
  height: 2.5rem;
  border: 1px solid #bfcbd5;
  border-radius: 6px;
  padding: 0 0.7rem;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.causale-error {
  color: #b42318;
  font-size: 0.9rem;
  font-weight: 700;
}

.causale-save-button {
  align-self: flex-end;
  border: 0;
  border-radius: 6px;
  background: #2367ad;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  padding: 0.65rem 1.1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  cursor: pointer;
}

.causale-save-button:disabled {
  opacity: 0.65;
  cursor: wait;
}

.modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.7rem;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  color: #666;
}

.modal-close:hover {
  color: #000;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.checkcodicicontoIcon {
  color: rgb(115 183 224);
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.subphase-navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.f24-empty-phase {
  margin: 24px 0;
  color: #5a6573;
  text-align: center;
}
.input-editable {
  width: 90%;
  min-height: 1.65rem;
  padding: 0.24rem 0.46rem;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #ffffff;
  font-size: 0.9em;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input-editable:focus {
  border-color: #7aa7d9;
  outline: none;
  box-shadow: 0 0 0 2px rgba(35, 103, 173, 0.14);
}

.client-table td {
  padding: 8px 10px;
}
.input-valorizzato {
  background: #f8f9fa;
  color: #333;
  border-color: #adb5bd;
  cursor: default;
}

.input-valorizzato:focus {
  outline: none;
}
.invalid-input {
  border-color: #e74c3c !important;
  background-color: #fff5f5;
}
</style>
